var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _polygon, _polygon2, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturned = function SvgReturned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M77.67,241.92c-95.18,54.94-95.18,144,0,199s249.49,54.95,344.66,0,95.18-144,0-199S172.84,187,77.67,241.92Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M202.91,224.62c-11.73,6.78-11.73,17.76,0,24.53s30.75,6.77,42.48,0,11.73-17.75,0-24.53S214.64,217.85,202.91,224.62Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 148.99,
    cy: 408.87,
    rx: 56.32,
    ry: 32.51,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 313.19,
    cy: 416.1,
    rx: 56.32,
    ry: 32.51,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M353.66,336.06l97.59,56.4c2.46,1.42,2.46,3.73,0,5.15l-65.72,38a9.83,9.83,0,0,1-8.9,0L279,379.16c-2.46-1.42-2.46-3.72,0-5.14l65.72-38A9.83,9.83,0,0,1,353.66,336.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M60.18,400.51l51.5,29.77c2.65,1.53,2.65,4,0,5.53l-36,20.82a10.55,10.55,0,0,1-9.57,0L14.59,426.86c-2.64-1.53-2.64-4,0-5.53l36-20.82A10.61,10.61,0,0,1,60.18,400.51Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "231.87 204.49 484.35 350.25 484.35 171.14 231.87 25.37 231.87 204.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.87 204.49 484.35 350.25 484.35 171.14 231.87 25.37 231.87 204.49",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plane--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.25,130.26l0,0,0,0a8.91,8.91,0,0,0-7.49-13.75,9.17,9.17,0,0,0-2.11.26l-.1,0c-5.23,1.16-19.13,5.58-29.17,12.14l13.09,21.63.43-.26c7.05-4.25,19.45-13.75,23.93-18.35a8.77,8.77,0,0,0,1.14-1.29l0,0A3.06,3.06,0,0,0,373.25,130.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,134.66c0,5.7,4,12.65,8.95,15.5s8.95.54,8.95-5.17-4-12.65-8.95-15.5S331.8,129,331.8,134.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.33,136.12a14.19,14.19,0,0,0,6.42,11.12c3.55,2,6.42.39,6.42-3.71a14.19,14.19,0,0,0-6.42-11.12C337.2,130.36,334.33,132,334.33,136.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.26 115.06 340.71 88.19 355.46 133.41 387.26 115.06",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.26,164.67s-60.28,34.82-68,39.27-21.36,10.71-31.73,11.64c-11.53,1-15.91-1.37-18.39-3.37-5.15-4.13-1.94-13.52,3.58-18.6a31.63,31.63,0,0,1,7.16-14.47c6-6.88,24.92-18,41.5-27.72s65.91-36.36,65.91-36.36l43,24.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.22,190.36l-2.2,6.22c-2.51-1-4-2.32-4.34-3a28.45,28.45,0,0,1,2-6.2A14.79,14.79,0,0,0,279.22,190.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,191.55l-.21,6.64a22.94,22.94,0,0,1-8.78-1.28l2.2-6.23A17.45,17.45,0,0,0,286.85,191.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,191.49a30.54,30.54,0,0,0,7.7-1.8v6.67a29.54,29.54,0,0,1-7.92,1.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,187v6.64a39.36,39.36,0,0,1-4.86,2.38v-6.67A34.7,34.7,0,0,0,301.33,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.22,190.36l-2.2,6.22c-2.51-1-4-2.32-4.34-3a28.45,28.45,0,0,1,2-6.2A14.79,14.79,0,0,0,279.22,190.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,191.55l-.21,6.64a22.94,22.94,0,0,1-8.78-1.28l2.2-6.23A17.45,17.45,0,0,0,286.85,191.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,191.49a30.54,30.54,0,0,0,7.7-1.8v6.67a29.54,29.54,0,0,1-7.92,1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,187v6.64a39.36,39.36,0,0,1-4.86,2.38v-6.67A34.7,34.7,0,0,0,301.33,187Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318,196.61a1.39,1.39,0,0,1-.72-.19,1.76,1.76,0,0,1-.77-1.62V181.34a4.6,4.6,0,0,1,2.13-3.68l4.05-2.34a1.75,1.75,0,0,1,1.79-.14,1.77,1.77,0,0,1,.78,1.62v13.46a4.66,4.66,0,0,1-2.13,3.69l-4.05,2.34A2.22,2.22,0,0,1,318,196.61Zm5.76-20.73a1.35,1.35,0,0,0-.63.2l-4.05,2.34a3.79,3.79,0,0,0-1.69,2.92V194.8a1,1,0,0,0,.34.86,1,1,0,0,0,.91-.14l4.05-2.34a3.8,3.8,0,0,0,1.69-2.92V176.8A1,1,0,0,0,324,176,.51.51,0,0,0,323.74,175.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.13,174.26v3.56c0,.73.52,1,1.15.66l1.29-.75a2.52,2.52,0,0,0,1.14-2v-3.56c0-.73-.51-1-1.14-.66l-1.29.75A2.53,2.53,0,0,0,337.13,174.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.61,161.86v3.55c0,.73.52,1,1.15.67l1.29-.75a2.52,2.52,0,0,0,1.14-2v-3.56c0-.73-.51-1-1.14-.66l-1.29.74A2.56,2.56,0,0,0,358.61,161.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.78,157.72v3.56c0,.73.51,1,1.14.66l1.29-.74a2.56,2.56,0,0,0,1.15-2v-3.55c0-.73-.52-1-1.15-.67l-1.29.75A2.52,2.52,0,0,0,365.78,157.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,153.59v3.56c0,.73.51,1,1.14.66l1.29-.75a2.53,2.53,0,0,0,1.15-2v-3.56c0-.73-.52-1-1.15-.66l-1.29.75A2.52,2.52,0,0,0,372.94,153.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,139.12v3.56c0,.73.51,1,1.14.66l1.29-.75a2.5,2.5,0,0,0,1.15-2v-3.56c0-.73-.51-1-1.15-.66l-1.29.75A2.52,2.52,0,0,0,398,139.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.16,135v3.56c0,.73.51,1,1.14.66l1.29-.74a2.54,2.54,0,0,0,1.15-2v-3.55c0-.73-.51-1-1.15-.66l-1.29.74A2.53,2.53,0,0,0,405.16,135Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.47,135.07l1.29-.75a2.52,2.52,0,0,0,1.14-2v-.74l-3.24-1.88a2.34,2.34,0,0,0-.34,1.13v3.56C412.32,135.14,412.83,135.43,413.47,135.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.1,149.45V153c0,.73.51,1,1.14.66l1.29-.74a2.54,2.54,0,0,0,1.15-2v-3.55c0-.73-.52-1-1.15-.66l-1.29.74A2.53,2.53,0,0,0,380.1,149.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.26,145.32v3.56c0,.73.51,1,1.14.66l1.29-.75a2.5,2.5,0,0,0,1.15-2v-3.56c0-.73-.51-1-1.15-.66l-1.29.75A2.52,2.52,0,0,0,387.26,145.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,170.13v3.55c0,.73.52,1,1.15.66l1.29-.74a2.53,2.53,0,0,0,1.14-2v-3.56c0-.73-.51-1-1.14-.66l-1.29.74A2.56,2.56,0,0,0,344.29,170.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.24,169.58l0,0,0-.05a8.91,8.91,0,0,0-7.49-13.75,8.65,8.65,0,0,0-2.11.27h-.1c-5.23,1.17-19.13,5.58-29.17,12.14l13.09,21.64.43-.26c7.05-4.25,19.45-13.76,23.93-18.36A8.77,8.77,0,0,0,441,169.9l0,0C441.1,169.77,441.18,169.68,441.24,169.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.79,174c0,5.71,4,12.65,8.95,15.5s8.95.55,8.95-5.16-4-12.65-8.95-15.51S399.79,168.26,399.79,174Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.32,175.43a14.19,14.19,0,0,0,6.42,11.13c3.55,2,6.42.38,6.42-3.71a14.19,14.19,0,0,0-6.42-11.13C405.19,169.67,402.32,171.33,402.32,175.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.68 162.35 469.16 162.35 426.64 137.8 383.68 162.35",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.55,239.32c-9.41-9.71-14.94-49.25-5.76-56.95h46.72c9.18,7.7,3.65,47.22-5.75,56.94l-.26.27-.33.32a10.63,10.63,0,0,1-.85.76c-.07.07-.15.12-.22.18-.23.19-.46.37-.71.55s-.81.55-1.22.78c-7.74,4.52-20.3,4.52-28,0h0a12.75,12.75,0,0,1-1.23-.79c-.23-.16-.44-.34-.66-.51l-.28-.22c-.29-.24-.56-.48-.82-.73l-.37-.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.45,179.27c10.66,6.22,10.66,16.31,0,22.53s-27.94,6.23-38.6,0-10.66-16.31,0-22.53S232.79,173,243.45,179.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.32,182.26c7.83,4.57,7.83,12,0,16.55s-20.52,4.57-28.35,0-7.82-12,0-16.55S230.5,177.69,238.32,182.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,190.11c7.83-4.57,20.53-4.57,28.35,0a13,13,0,0,1,4.69,4.35,12.94,12.94,0,0,1-4.69,4.35c-7.82,4.57-20.52,4.57-28.35,0a13,13,0,0,1-4.68-4.35A13.07,13.07,0,0,1,210,190.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.23,119.26l15.55,12.34-15-6.95a41.57,41.57,0,0,0,2.61,14.25,92.72,92.72,0,0,1,11.72,8.3l-11.54-4.55s-.79,7.6,2.38,19.19c.82,3,4.23,8.83,6.39,13.17a49.7,49.7,0,0,0,3.35,5.78c.07.12.15.23.23.35q4-2.26,8.22-4.38c1.85-3.9,4.27-13.53,5.14-21.42,3.32-30.18-19.5-47.48-37.85-53.28C196.39,102.06,202.69,110,205.23,119.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,119.26l15.55,12.34-15-6.95a41.57,41.57,0,0,0,2.61,14.25,92.72,92.72,0,0,1,11.72,8.3l-11.54-4.55s-.79,7.6,2.38,19.19c.82,3,4.23,8.83,6.39,13.17a49.7,49.7,0,0,0,3.35,5.78c.07.12.15.23.23.35q4-2.26,8.22-4.38c1.85-3.9,4.27-13.53,5.14-21.42,3.32-30.18-19.5-47.48-37.85-53.28C196.39,102.06,202.69,110,205.23,119.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.24,120.53c3.17,3.19,5,7.39,6.45,11.59a60.75,60.75,0,0,1,2.76,13.06,56.54,56.54,0,0,1-3.29,26.21h0a.44.44,0,1,0,.81.32h0a57.26,57.26,0,0,0,2.91-26.58,61.11,61.11,0,0,0-3-13.08C223.4,127.86,221.46,123.67,218.24,120.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.56,135.09l0,0A234.91,234.91,0,0,0,256.28,158l-15.78,2.54,11.64,2-6.25,9.9-15.53,3.21,12.12,2s-3.36,11.83-12,16.77c-4.8,2.72-7.14,3.14-8.58,1.77-1-1-1.24-6.63-2.08-11.7s-.9-13.31,3.88-23.25a30.81,30.81,0,0,1,5-7.3C240.12,141.1,261.82,134.93,272.56,135.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.56,135.09l0,0A234.91,234.91,0,0,0,256.28,158l-15.78,2.54,11.64,2-6.25,9.9-15.53,3.21,12.12,2s-3.36,11.83-12,16.77c-4.8,2.72-7.14,3.14-8.58,1.77-1-1-1.24-6.63-2.08-11.7s-.9-13.31,3.88-23.25a30.81,30.81,0,0,1,5-7.3C240.12,141.1,261.82,134.93,272.56,135.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.05,140.25a64.36,64.36,0,0,0-22,15.17,43.07,43.07,0,0,0-7.51,11.16,41.05,41.05,0,0,0-3.44,13,0,0,0,0,0,0,0,.05.05,0,0,0,0,0A52.38,52.38,0,0,1,227.37,167a48.45,48.45,0,0,1,7.24-11.07c5.87-6.68,13.43-11.74,21.47-15.55a0,0,0,0,0,0-.05S256.07,140.25,256.05,140.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,141.61h0a31.36,31.36,0,0,1,4,.18,63.37,63.37,0,0,1,15.19,3.7c1.81.67,3.63,1.44,5.43,2.29.89.43,1.78.88,2.65,1.35a44.13,44.13,0,0,1,11.64,8.8,27.78,27.78,0,0,1,4,5.63c.14.27.29.52.42.79h0c.34.69.65,1.37.94,2a38,38,0,0,1,3.42,18.69c-.16,4.53-1.7,9.7-2.58,10.55a2.32,2.32,0,0,1-.4.3c-1.29.82-3.34.34-7.18-1.81-7.69-4.3-10.71-15.2-10.71-15.2l-3-4.55-5.57-8.7L207,163.82,193,161.68a207.83,207.83,0,0,0-14.48-20.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,141.61h0a31.36,31.36,0,0,1,4,.18,63.37,63.37,0,0,1,15.19,3.7c1.81.67,3.63,1.44,5.43,2.29.89.43,1.78.88,2.65,1.35a44.13,44.13,0,0,1,11.64,8.8,27.78,27.78,0,0,1,4,5.63c.14.27.29.52.42.79h0c.34.69.65,1.37.94,2a38,38,0,0,1,3.42,18.69c-.16,4.53-1.7,9.7-2.58,10.55a2.32,2.32,0,0,1-.4.3c-1.29.82-3.34.34-7.18-1.81-7.69-4.3-10.71-15.2-10.71-15.2l-3-4.55-5.57-8.7L207,163.82,193,161.68a207.83,207.83,0,0,0-14.48-20.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5,141.79a63.37,63.37,0,0,1,15.19,3.7c1.81.67,3.63,1.44,5.43,2.29.89.43,1.78.88,2.65,1.35a44.13,44.13,0,0,1,11.64,8.8,27.78,27.78,0,0,1,4,5.63c.14.27.29.52.42.79h0c.34.69.65,1.37.94,2a38,38,0,0,1,3.42,18.69c-.16,4.53-1.7,9.7-2.58,10.55a2.32,2.32,0,0,1-.4.3,2.56,2.56,0,0,1-.84.31c.94-7-2.51-24.83-7.74-32.15-5.44-7.62-18.35-18.67-36.09-22.49h0A30.83,30.83,0,0,1,182.5,141.79Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.42,196.26a60,60,0,0,0-1-15.53A50.34,50.34,0,0,0,216.26,166a43.6,43.6,0,0,0-10.43-11.64,58.3,58.3,0,0,0-13.38-8s0,0,0,0a0,0,0,0,0,0,.06A76.6,76.6,0,0,1,205.28,155a57.29,57.29,0,0,1,5.65,5.25,34.16,34.16,0,0,1,4.73,6.07A49.48,49.48,0,0,1,221,180.82a59.69,59.69,0,0,1,1.35,15.43,0,0,0,0,0,.09,0Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.71,22.81l-128.13,74a3,3,0,0,0-1.37,2.37v37a3,3,0,0,0,1.38,2.36l4.92,2.76a3.09,3.09,0,0,0,2.75,0l128.12-74a3,3,0,0,0,1.38-2.37v-37a3,3,0,0,0-1.39-2.36l-4.91-2.76A3.06,3.06,0,0,0,178.71,22.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,140.47v-37a3,3,0,0,1,1.37-2.38l128.12-74c.76-.44,1.38-.08,1.38.79v37a3,3,0,0,1-1.38,2.37l-128.12,74C57.5,141.7,56.89,141.35,56.89,140.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,141.27a3.16,3.16,0,0,1-2.75,0l-4.92-2.76a3,3,0,0,1-1.38-2.36v-37a2.83,2.83,0,0,1,.44-1.4l7.64,4.37a2.74,2.74,0,0,0-.4,1.35v37A.86.86,0,0,0,58.26,141.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.74,27.66c-.11-.69-.68-.94-1.36-.54l-128.12,74a2.84,2.84,0,0,0-1,1l-7.65-4.37a2.82,2.82,0,0,1,.94-1l128.13-74a3.09,3.09,0,0,1,2.75,0l4.91,2.76A3.05,3.05,0,0,1,187.74,27.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180,42.22a1.36,1.36,0,0,0-1.35,0l-10.41,6a1.36,1.36,0,0,0,1.36,2.35l6.66-3.85-8.86,18.75a1.35,1.35,0,0,0,.65,1.8,1.28,1.28,0,0,0,.57.13,1.36,1.36,0,0,0,1.23-.78l8.12-17.2v10a1.36,1.36,0,0,0,2.71,0v-16A1.34,1.34,0,0,0,180,42.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,126.57c.39.38,1.07-.93,1.07-.93l1.57,2.15.24-.5L66,123.2s2-3.09,4.53-7.71l5.6,5.36.27-.56-2.62-7.41.58-1.23a.45.45,0,0,0,0-.56c-.14-.08-.34,0-.44.26l-.36.76L73,110.68c2.75-5.76,4.27-9.71,3.25-10.7s-3,2.51-5.73,8.31l-1.12-.13.36-.76a.83.83,0,0,0,0-.69c-.11-.15-.28-.09-.38.14l-.58,1.24L63,107.4l-.26.57,5.58,5.39c-2.06,5-3.3,8.89-3.3,8.89l-2.88.77-.24.52,2,1.27S63.25,126.19,63.64,126.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.16,97.82a3.17,3.17,0,0,1,1.42-.49,1.33,1.33,0,0,1,1,.37,2.35,2.35,0,0,1,.62,1.12,7.82,7.82,0,0,1,.26,1.79c0,.82,0,1.66,0,2.51a12.57,12.57,0,0,1-.26,2.09,8.55,8.55,0,0,1-.61,1.83,6.57,6.57,0,0,1-1,1.51,5.43,5.43,0,0,1-1.39,1.13l-2.78,1.61a.15.15,0,0,1-.21,0,.34.34,0,0,1-.08-.27V100a.87.87,0,0,1,.08-.38.63.63,0,0,1,.21-.26ZM90,101.47a4.14,4.14,0,0,0-.14-.94,1.37,1.37,0,0,0-.34-.61.77.77,0,0,0-.57-.22,1.6,1.6,0,0,0-.81.28l-1.49.85v7.65l1.54-.89a2.88,2.88,0,0,0,.78-.65,3.44,3.44,0,0,0,.55-.85,4.61,4.61,0,0,0,.34-1A6.75,6.75,0,0,0,90,104C90,103.13,90,102.29,90,101.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6,101.56a.17.17,0,0,1,.21,0,.37.37,0,0,1,.09.27v1.21a.84.84,0,0,1-.09.37.63.63,0,0,1-.21.26l-4.84,2.79c-.09,0-.15,0-.21,0a.37.37,0,0,1-.09-.27v-11a.84.84,0,0,1,.09-.37.52.52,0,0,1,.21-.26l4.75-2.75a.17.17,0,0,1,.21,0,.35.35,0,0,1,.09.27v1.21a.87.87,0,0,1-.09.37.57.57,0,0,1-.21.26L95,96v2.71l3.32-1.92a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.2a.88.88,0,0,1-.09.38.54.54,0,0,1-.21.25L95,100.85v2.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.08,88.63c.89-.51,1.58-.59,2.07-.23s.74,1.17.74,2.41a7.06,7.06,0,0,1-.74,3.29,5.31,5.31,0,0,1-2.07,2.18l-1.77,1v3.79a.84.84,0,0,1-.09.37.57.57,0,0,1-.21.26l-.89.51a.15.15,0,0,1-.21,0,.37.37,0,0,1-.09-.27V91a.81.81,0,0,1,.09-.37.57.57,0,0,1,.21-.26Zm-1.77,6.54,1.71-1a3,3,0,0,0,1-1,2.87,2.87,0,0,0,.37-1.55c0-.63-.12-1-.37-1.1a1.19,1.19,0,0,0-1,.22l-1.71,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.81,84.16c.12-.06.21-.07.27,0a.83.83,0,0,1,.15.35l2.71,9.18a.37.37,0,0,1,0,.11.81.81,0,0,1-.09.37.52.52,0,0,1-.21.26l-.79.46c-.15.08-.25.1-.31,0a.57.57,0,0,1-.13-.21L113,93.09l-3.49,2L109,97.27a1.62,1.62,0,0,1-.12.35.73.73,0,0,1-.31.32l-.8.46a.17.17,0,0,1-.21,0,.34.34,0,0,1-.09-.27s0-.09,0-.12l2.71-12.31a2.34,2.34,0,0,1,.15-.52.66.66,0,0,1,.27-.3Zm.61,7.11-1.21-4.14L110,92.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.65,79.64c.92-.53,1.62-.61,2.1-.23a2.93,2.93,0,0,1,.71,2.32,7.17,7.17,0,0,1-.37,2.34A5.85,5.85,0,0,1,121,86l1.52,3.32a.51.51,0,0,1,0,.17.66.66,0,0,1-.07.3.46.46,0,0,1-.17.21l-.94.54c-.14.09-.25.1-.32,0a.69.69,0,0,1-.15-.21l-1.45-3.12-1.47.84v4a1,1,0,0,1-.08.38.54.54,0,0,1-.21.25l-.9.52a.15.15,0,0,1-.21,0,.34.34,0,0,1-.09-.27v-11a.87.87,0,0,1,.09-.37.63.63,0,0,1,.21-.26ZM118,86l1.6-.93a2.89,2.89,0,0,0,1-.92,2.64,2.64,0,0,0,.37-1.5c0-.64-.12-1-.37-1.06a1.4,1.4,0,0,0-1,.25l-1.6.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.52,73.94a.15.15,0,0,1,.21,0,.34.34,0,0,1,.09.27v1.21a.87.87,0,0,1-.09.37.63.63,0,0,1-.21.26l-2,1.14v9.32a.87.87,0,0,1-.09.37.63.63,0,0,1-.21.26l-.89.51a.16.16,0,0,1-.21,0,.37.37,0,0,1-.09-.27V78.07l-2,1.15a.16.16,0,0,1-.21,0,.38.38,0,0,1-.08-.28v-1.2a.87.87,0,0,1,.08-.38.54.54,0,0,1,.21-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.44,69.37a.15.15,0,0,1,.21,0,.37.37,0,0,1,.09.27v7a9.48,9.48,0,0,1-.2,2,7.62,7.62,0,0,1-.6,1.8A6.22,6.22,0,0,1,136,82a5.22,5.22,0,0,1-1.38,1.13,3.09,3.09,0,0,1-1.38.47,1.34,1.34,0,0,1-1-.37,2.33,2.33,0,0,1-.59-1.13,7.06,7.06,0,0,1-.19-1.79v-7a.87.87,0,0,1,.08-.38.63.63,0,0,1,.21-.26l.9-.51a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28v6.88a4.3,4.3,0,0,0,.12,1.12,1.22,1.22,0,0,0,.34.61.7.7,0,0,0,.53.15,1.68,1.68,0,0,0,.67-.25,2.84,2.84,0,0,0,.68-.53,3.12,3.12,0,0,0,.54-.77,4.43,4.43,0,0,0,.34-1,5.48,5.48,0,0,0,.13-1.26V70.51a.88.88,0,0,1,.09-.38.54.54,0,0,1,.21-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.11,66.1c.92-.53,1.61-.61,2.09-.23a2.89,2.89,0,0,1,.72,2.32,7.07,7.07,0,0,1-.37,2.33,5.82,5.82,0,0,1-1.09,1.93L146,75.77a.33.33,0,0,1,0,.17.82.82,0,0,1-.07.3.54.54,0,0,1-.17.21l-.94.54q-.22.14-.33,0a.69.69,0,0,1-.15-.21l-1.44-3.13-1.47.85v4a.84.84,0,0,1-.09.37.57.57,0,0,1-.21.26l-.89.52a.17.17,0,0,1-.21,0,.35.35,0,0,1-.09-.27v-11a.84.84,0,0,1,.09-.37.57.57,0,0,1,.21-.26Zm-1.66,6.3,1.6-.92a3,3,0,0,0,1-.92,2.66,2.66,0,0,0,.38-1.51c0-.63-.13-1-.38-1a1.37,1.37,0,0,0-1,.25l-1.6.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.05,70.13a.16.16,0,0,1,.21,0,.37.37,0,0,1,.09.27v1.21a.84.84,0,0,1-.09.37.57.57,0,0,1-.21.26l-4.84,2.8a.17.17,0,0,1-.22,0,.34.34,0,0,1-.08-.27v-11a.83.83,0,0,1,.08-.37.58.58,0,0,1,.22-.26L153,60.41a.16.16,0,0,1,.21,0,.37.37,0,0,1,.09.27V61.9a.84.84,0,0,1-.09.37.57.57,0,0,1-.21.26l-3.56,2.06v2.7l3.32-1.92a.17.17,0,0,1,.21,0,.34.34,0,0,1,.09.27v1.21a.84.84,0,0,1-.09.37.57.57,0,0,1-.21.26l-3.32,1.92v2.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.92,57.38a2.81,2.81,0,0,1,1.3-.45,1.62,1.62,0,0,1,.94.22,1.5,1.5,0,0,1,.57.69,2.63,2.63,0,0,1,.21.92.69.69,0,0,1-.08.37.53.53,0,0,1-.22.26l-.77.44c-.12.08-.22.09-.28.05a.46.46,0,0,1-.17-.19.88.88,0,0,0-.5-.45,1.29,1.29,0,0,0-1,.26,3,3,0,0,0-.55.41,3.24,3.24,0,0,0-.45.53,2.47,2.47,0,0,0-.3.61,1.8,1.8,0,0,0-.11.64,1.26,1.26,0,0,0,.1.58.45.45,0,0,0,.35.22,2,2,0,0,0,.66-.05c.27,0,.61-.13,1-.23a4.31,4.31,0,0,1,1.15-.14,1.28,1.28,0,0,1,.78.26,1.47,1.47,0,0,1,.45.7,3.77,3.77,0,0,1,.15,1.15,5.58,5.58,0,0,1-.22,1.55,6.29,6.29,0,0,1-.63,1.49,6.56,6.56,0,0,1-1,1.32,6.42,6.42,0,0,1-1.34,1,3.4,3.4,0,0,1-1.18.45,1.66,1.66,0,0,1-1-.09,1.39,1.39,0,0,1-.7-.64,2.76,2.76,0,0,1-.3-1.18.73.73,0,0,1,.09-.38.54.54,0,0,1,.21-.25l.78-.45a.32.32,0,0,1,.28-.06.38.38,0,0,1,.17.21,1.35,1.35,0,0,0,.19.33.53.53,0,0,0,.29.22,1,1,0,0,0,.47,0,2.28,2.28,0,0,0,.7-.3,3.84,3.84,0,0,0,.64-.44,2.9,2.9,0,0,0,.54-.57,3.13,3.13,0,0,0,.38-.66,2,2,0,0,0,.14-.73.75.75,0,0,0-.15-.53.6.6,0,0,0-.47-.13,3.81,3.81,0,0,0-.78.12c-.31.08-.67.16-1.07.23a3.06,3.06,0,0,1-1,.07,1.08,1.08,0,0,1-.68-.29,1.55,1.55,0,0,1-.4-.73,4.66,4.66,0,0,1-.13-1.24,5.51,5.51,0,0,1,.22-1.54,6.61,6.61,0,0,1,.6-1.45,7.14,7.14,0,0,1,.92-1.26A4.94,4.94,0,0,1,157.92,57.38Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Seats--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--seats--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.11 290.53 49.21 375.91 112.59 412.51 260.49 327.12 197.11 290.53",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sit--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "54.49 330.17 54.49 348.47 91.47 369.81 91.47 351.52 54.49 330.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.47 369.81 107.31 360.67 91.47 351.52 91.47 369.81",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.59 345.42 65.05 317.97 65.06 317.97 59.77 247.83 49.21 241.73 49.21 327.12 112.59 363.72 112.59 345.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.59 345.42 65.05 317.97 65.06 317.97 59.77 247.83 49.21 241.73 49.21 327.12 112.59 363.72 112.59 345.42",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.59 345.42 65.05 317.97 65.06 317.97 59.77 247.83 49.21 241.73 49.21 327.12 112.59 363.72 112.59 345.42",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.59 345.42 260.49 260.03 260.49 278.33 112.59 363.72 112.59 345.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.59 345.42 260.49 260.03 260.49 278.33 112.59 363.72 112.59 345.42",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.06 317.97 212.95 232.59 260.49 260.03 112.59 345.42 65.06 317.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.06 317.97 212.95 232.59 260.49 260.03 112.59 345.42 65.06 317.97",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.1 156.34 49.21 241.73 59.77 247.83 207.67 162.44 197.1 156.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.1 156.34 49.21 241.73 59.77 247.83 207.67 162.44 197.1 156.34",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.67 162.44 212.95 232.59 65.06 317.97 59.77 247.83 207.67 162.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.67 162.44 212.95 232.59 65.06 317.97 59.77 247.83 207.67 162.44",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,336.07a12.5,12.5,0,0,0,11.27,0l31-17.9c3.11-1.79,3.11-4.7,0-6.5l-36.63-21.14L70.34,314.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,257.14a11.38,11.38,0,0,1,5.18-9.74l31-17.89c3.11-1.8,5.83-.35,6.08,3.23l4.43,57.79L70.34,314.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,257.14a11.38,11.38,0,0,1,5.18-9.74l31-17.89c3.11-1.8,5.83-.35,6.08,3.23l4.43,57.79L70.34,314.92Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,308.62a12.41,12.41,0,0,0,11.26,0l31-17.89c3.11-1.8,3.11-4.71,0-6.5l-36.63-21.15-42.25,24.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.44,229.69a11.38,11.38,0,0,1,5.18-9.74l31-17.89c3.11-1.79,5.83-.35,6.08,3.24l4.43,57.78-42.25,24.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.44,229.69a11.38,11.38,0,0,1,5.18-9.74l31-17.89c3.11-1.79,5.83-.35,6.08,3.24l4.43,57.78-42.25,24.4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,281.18a12.48,12.48,0,0,0,11.26,0l31-17.9c3.11-1.79,3.11-4.71,0-6.5l-36.63-21.15L165.41,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,202.25a11.36,11.36,0,0,1,5.18-9.74l31-17.9c3.11-1.79,5.84-.34,6.08,3.24l4.44,57.78L165.41,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,202.25a11.36,11.36,0,0,1,5.18-9.74l31-17.9c3.11-1.79,5.84-.34,6.08,3.24l4.44,57.78L165.41,260Z",
    style: {
      opacity: 0.15
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 35.7 466.51 113.22 466.51 213.94 332.25 136.42 332.25 35.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.79 134.76 334.79 41.18 463.97 115.76 463.97 209.35 334.79 134.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 131.85 334.79 134.76 334.79 41.18 339.84 44.1 339.84 131.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 131.85 463.97 203.51 463.97 115.76 339.84 44.1 339.84 131.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 44.1 340.09 66.04 340.24 87.97 340.33 131.85 340.09 131.42 374.48 151.42 391.64 161.49 408.75 171.64 391.41 161.89 374.11 152.06 339.59 132.27 339.35 132.13 339.35 131.85 339.44 87.97 339.59 66.04 339.84 44.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 35.7 337.62 32.6 471.88 110.12 466.51 113.22 332.25 35.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.88 110.12 471.88 210.84 466.51 213.94 466.51 113.22 471.88 110.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,86.48h4.17v15.67h0a1,1,0,0,1-.59.95,3.26,3.26,0,0,1-2.95,0,1,1,0,0,1-.6-.95h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.16,86.48c0,.63-.94,1.14-2.09,1.14S451,87.11,451,86.48s.93-1.15,2.08-1.15S455.16,85.84,455.16,86.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,30.66h4.17V46.33h0a1,1,0,0,1-.59,1,3.26,3.26,0,0,1-2.95,0,1,1,0,0,1-.6-1h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.49,30.66c0,.64-.94,1.15-2.09,1.15s-2.08-.51-2.08-1.15.93-1.14,2.08-1.14S358.49,30,358.49,30.66Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.34,65.78c-.2.19-.54-.48-.54-.48L348,66.4l-.13-.26.29-2.07s-1-1.57-2.3-3.91L343,62.88l-.14-.29,1.33-3.76-.3-.62c-.05-.11,0-.24,0-.28s.17,0,.22.13l.19.38.25-.72c-1.39-2.92-2.16-4.92-1.64-5.42s1.53,1.27,2.9,4.21l.57-.07-.18-.38a.36.36,0,0,1,0-.35c.05-.08.14-.05.19.07l.29.63,2.94-.35.14.29L347,59.08c1,2.55,1.67,4.51,1.67,4.51l1.46.39.12.26-1,.64S349.54,65.59,349.34,65.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.54,60a5,5,0,0,1,1.21,1,5.5,5.5,0,0,1,.86,1.31,6.9,6.9,0,0,1,.53,1.57,10.18,10.18,0,0,1,.23,1.79c0,.73,0,1.45,0,2.15a6.33,6.33,0,0,1-.23,1.53,2.08,2.08,0,0,1-.52,1,1.17,1.17,0,0,1-.85.32,2.65,2.65,0,0,1-1.19-.4l-2.38-1.38a.46.46,0,0,1-.18-.22.74.74,0,0,1-.07-.32V58.9a.32.32,0,0,1,.07-.23.14.14,0,0,1,.18,0Zm1.55,4.91A4.73,4.73,0,0,0,358,64a4,4,0,0,0-.29-.87,3.34,3.34,0,0,0-.49-.75,2.82,2.82,0,0,0-.7-.57l-1.27-.73v6.55l1.32.76a1.38,1.38,0,0,0,.67.22.61.61,0,0,0,.47-.19,1.17,1.17,0,0,0,.29-.53,3.13,3.13,0,0,0,.12-.8Q358.12,66,358.09,64.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,73.27a.46.46,0,0,1,.18.22.76.76,0,0,1,.08.32v1a.32.32,0,0,1-.08.23.14.14,0,0,1-.18,0l-4.15-2.39a.54.54,0,0,1-.18-.23.72.72,0,0,1-.08-.32v-9.4a.33.33,0,0,1,.08-.24.15.15,0,0,1,.18,0l4.08,2.36a.51.51,0,0,1,.17.22.72.72,0,0,1,.08.32v1a.3.3,0,0,1-.08.23.12.12,0,0,1-.17,0l-3.06-1.77v2.32l2.85,1.64a.46.46,0,0,1,.18.22.77.77,0,0,1,.07.32v1a.33.33,0,0,1-.07.24.14.14,0,0,1-.18,0l-2.85-1.64v2.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.23,67.34A4.6,4.6,0,0,1,371,69.19a5.93,5.93,0,0,1,.63,2.8,2.56,2.56,0,0,1-.63,2.08c-.43.32-1,.26-1.78-.18L367.71,73v3.25a.3.3,0,0,1-.07.23.14.14,0,0,1-.18,0l-.77-.45a.46.46,0,0,1-.18-.22.71.71,0,0,1-.07-.32v-9.4a.33.33,0,0,1,.07-.24.15.15,0,0,1,.18,0Zm-1.52,3.85,1.47.85a1,1,0,0,0,.86.17c.22-.1.32-.42.32-1a2.33,2.33,0,0,0-.32-1.31,2.31,2.31,0,0,0-.86-.81l-1.47-.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.38,70.89a.51.51,0,0,1,.23.25,1.88,1.88,0,0,1,.13.45l2.32,10.54a.37.37,0,0,1,0,.11.32.32,0,0,1-.08.23.14.14,0,0,1-.18,0l-.68-.39a.59.59,0,0,1-.26-.28,1.6,1.6,0,0,1-.11-.3l-.4-1.85-3-1.72L373,79.32a.46.46,0,0,1-.1.18q-.08.07-.27,0l-.68-.39a.51.51,0,0,1-.18-.22.77.77,0,0,1-.07-.32.31.31,0,0,1,0-.1L374,70.58a.65.65,0,0,1,.13-.3c.05,0,.12,0,.22,0Zm.52,6.69-1-4.75-1,3.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,74.49a4.56,4.56,0,0,1,1.79,1.88,5.84,5.84,0,0,1,.62,2.7,3.38,3.38,0,0,1-.32,1.63,1,1,0,0,1-.93.58l1.3,4.35a.67.67,0,0,1,0,.17.3.3,0,0,1-.06.2.13.13,0,0,1-.15,0l-.8-.47a.63.63,0,0,1-.28-.3,2.47,2.47,0,0,1-.13-.33l-1.24-4.1-1.25-.73v3.39a.29.29,0,0,1-.08.23.14.14,0,0,1-.18,0l-.76-.45a.41.41,0,0,1-.18-.22.72.72,0,0,1-.08-.32v-9.4a.29.29,0,0,1,.08-.23.14.14,0,0,1,.18,0Zm-1.42,3.77,1.37.79a1.11,1.11,0,0,0,.86.21c.21-.07.32-.38.32-.92a2.24,2.24,0,0,0-.32-1.28,2.7,2.7,0,0,0-.86-.78l-1.37-.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,79.1a.51.51,0,0,1,.18.22.77.77,0,0,1,.07.32v1a.33.33,0,0,1-.07.24.14.14,0,0,1-.18,0l-1.71-1v8a.32.32,0,0,1-.07.23.14.14,0,0,1-.18,0l-.77-.44a.46.46,0,0,1-.18-.22.74.74,0,0,1-.07-.32v-8l-1.71-1a.58.58,0,0,1-.17-.22.79.79,0,0,1-.08-.32v-1a.32.32,0,0,1,.08-.23.12.12,0,0,1,.17,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.92,82.75a.46.46,0,0,1,.18.22.76.76,0,0,1,.08.32v6a6.1,6.1,0,0,1-.17,1.53,2.18,2.18,0,0,1-.51,1,1.16,1.16,0,0,1-.85.31,2.58,2.58,0,0,1-1.19-.39,4.67,4.67,0,0,1-1.18-1,5.44,5.44,0,0,1-.85-1.29,6.54,6.54,0,0,1-.5-1.55,8,8,0,0,1-.17-1.72v-6c0-.11,0-.19.08-.23a.12.12,0,0,1,.17,0l.77.45a.46.46,0,0,1,.18.22.72.72,0,0,1,.08.32v5.89a5.09,5.09,0,0,0,.1,1.08,3.94,3.94,0,0,0,.29.86,2.68,2.68,0,0,0,.46.66,3.11,3.11,0,0,0,.57.46,1.75,1.75,0,0,0,.59.21.54.54,0,0,0,.45-.13,1,1,0,0,0,.3-.52,3.51,3.51,0,0,0,.11-1V82.56a.33.33,0,0,1,.08-.24.14.14,0,0,1,.18,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3,85.27a4.55,4.55,0,0,1,1.8,1.89,5.8,5.8,0,0,1,.61,2.7,3.25,3.25,0,0,1-.32,1.62,1,1,0,0,1-.93.58l1.31,4.35a.67.67,0,0,1,0,.18.27.27,0,0,1-.06.19.12.12,0,0,1-.15,0l-.8-.47a.63.63,0,0,1-.28-.3,1.53,1.53,0,0,1-.13-.32l-1.24-4.11-1.26-.73v3.39a.33.33,0,0,1-.07.24.15.15,0,0,1-.18,0l-.77-.44a.51.51,0,0,1-.18-.22.77.77,0,0,1-.07-.32V84.11a.3.3,0,0,1,.07-.23.14.14,0,0,1,.18,0ZM398.88,89l1.37.79a1.12,1.12,0,0,0,.86.21c.22-.07.33-.38.33-.92a2.16,2.16,0,0,0-.33-1.28,2.47,2.47,0,0,0-.86-.77l-1.37-.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35,98.29a.46.46,0,0,1,.18.22.77.77,0,0,1,.07.32v1a.32.32,0,0,1-.07.23.14.14,0,0,1-.18,0l-4.15-2.39a.51.51,0,0,1-.18-.22.79.79,0,0,1-.08-.32V87.77a.3.3,0,0,1,.08-.23.15.15,0,0,1,.18,0l4.07,2.36a.46.46,0,0,1,.18.22.72.72,0,0,1,.08.32v1a.29.29,0,0,1-.08.23.14.14,0,0,1-.18,0l-3-1.77v2.32l2.84,1.64a.46.46,0,0,1,.18.22.79.79,0,0,1,.08.32v1a.32.32,0,0,1-.08.23.14.14,0,0,1-.18,0l-2.84-1.64v2.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.05,91.91a4.43,4.43,0,0,1,1.11.91,5.92,5.92,0,0,1,.8,1.12,5.09,5.09,0,0,1,.49,1.14,4.89,4.89,0,0,1,.19,1,.33.33,0,0,1-.07.24.17.17,0,0,1-.19,0l-.66-.38a.56.56,0,0,1-.24-.24,1.7,1.7,0,0,1-.15-.33,3.47,3.47,0,0,0-.43-.89,2.54,2.54,0,0,0-.85-.76,1.78,1.78,0,0,0-.47-.19.72.72,0,0,0-.39,0,.47.47,0,0,0-.26.22.93.93,0,0,0-.09.44,1.64,1.64,0,0,0,.09.6,2.11,2.11,0,0,0,.3.54,5.8,5.8,0,0,0,.56.6q.34.35.87.81a11.4,11.4,0,0,1,1,1,5.46,5.46,0,0,1,.67,1,5.12,5.12,0,0,1,.39,1,5.22,5.22,0,0,1,.12,1.13,3,3,0,0,1-.18,1.11,1.31,1.31,0,0,1-.54.65,1.41,1.41,0,0,1-.86.14,3.16,3.16,0,0,1-1.15-.43,5.17,5.17,0,0,1-1-.78,5.81,5.81,0,0,1-.85-1.06,6.29,6.29,0,0,1-.61-1.25,4.6,4.6,0,0,1-.25-1.31.27.27,0,0,1,.07-.24.15.15,0,0,1,.18,0l.67.38a.66.66,0,0,1,.24.23,1,1,0,0,1,.14.34c.05.15.1.31.17.47a2.06,2.06,0,0,0,.25.49,3.34,3.34,0,0,0,.4.47,2.91,2.91,0,0,0,.6.44,2.94,2.94,0,0,0,.55.25.86.86,0,0,0,.46.05.48.48,0,0,0,.32-.19.75.75,0,0,0,.13-.49,1.32,1.32,0,0,0-.13-.6A2.49,2.49,0,0,0,413,99c-.18-.2-.4-.43-.66-.67s-.57-.52-.92-.86a11.12,11.12,0,0,1-.83-.89,5.12,5.12,0,0,1-.58-.93,4.39,4.39,0,0,1-.35-1,6.29,6.29,0,0,1-.11-1.2,2.78,2.78,0,0,1,.19-1.1,1.3,1.3,0,0,1,.52-.64,1.27,1.27,0,0,1,.79-.17A2.63,2.63,0,0,1,412.05,91.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,78,346,77.31a.46.46,0,0,1-.15-.18.66.66,0,0,1-.06-.27.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l.43.24V73.64a1.12,1.12,0,0,0-.13-.53.81.81,0,0,0-.29-.37h0a.39.39,0,0,1-.15-.18.66.66,0,0,1-.06-.27.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0h0a1.46,1.46,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v3.27l.42.24a.41.41,0,0,1,.16.18.66.66,0,0,1,.06.27.21.21,0,0,1-.07.19A.11.11,0,0,1,347.24,78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73,75.47a.35.35,0,0,0,0,.14.24.24,0,0,0,.08.09l1.16.67a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v.65a1,1,0,0,1-.25.78.46.46,0,0,1-.6,0l-.84-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07.24.24,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.63.63,0,0,1,.06.27,1.15,1.15,0,0,0,.13.53.74.74,0,0,0,.3.36L350,79a.24.24,0,0,0,.3,0,.5.5,0,0,0,.13-.39v-.66a1.12,1.12,0,0,0-.13-.53A.77.77,0,0,0,350,77l-1.27-.73a.85.85,0,0,1-.3-.36,1.32,1.32,0,0,1-.12-.54V73.76a.28.28,0,0,1,.06-.2s.09,0,.15,0l2.12,1.22a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.8-1a.06.06,0,0,0-.08,0,.16.16,0,0,0,0,.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,78.11a.18.18,0,0,1,.06.08.2.2,0,0,1,0,.11v.51a.12.12,0,0,1,0,.09s0,0-.06,0l-.32-.18a.17.17,0,0,1-.06-.08.27.27,0,0,1,0-.12V78a.1.1,0,0,1,0-.08s0,0,.06,0Zm0,1.82L352,80a.27.27,0,0,1,0,.12v.51s0,.07,0,.08a0,0,0,0,1-.06,0l-.32-.18a.17.17,0,0,1-.06-.08.27.27,0,0,1,0-.12v-.51s0-.07,0-.08,0,0,.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,82.13l-.85-.49a1.67,1.67,0,0,1-.6-.73,2.56,2.56,0,0,1-.24-1.07V77.23a1.07,1.07,0,0,1,.24-.78.45.45,0,0,1,.6,0l.85.49a1.46,1.46,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v2.61a1,1,0,0,1-.25.78A.46.46,0,0,1,354.32,82.13ZM353.47,81l.85.49a.29.29,0,0,0,.2,0l-1.47-4v2.56a1.24,1.24,0,0,0,.12.53A.9.9,0,0,0,353.47,81Zm.85-3.43-.85-.49a.29.29,0,0,0-.2,0l1.48,4V78.46a1.34,1.34,0,0,0-.13-.54A.79.79,0,0,0,354.32,77.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,84.09l-.85-.49a1.6,1.6,0,0,1-.59-.73A2.43,2.43,0,0,1,356,81.8V79.19a1,1,0,0,1,.25-.78.44.44,0,0,1,.59,0l.85.48a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v2.61a1,1,0,0,1-.25.78A.46.46,0,0,1,357.71,84.09Zm-.85-1.15.85.49a.3.3,0,0,0,.2,0l-1.47-4v2.56a1.15,1.15,0,0,0,.13.53A.73.73,0,0,0,356.86,82.94Zm.85-3.42-.85-.49a.29.29,0,0,0-.2,0l1.48,4V80.42a1.16,1.16,0,0,0-.13-.54A.79.79,0,0,0,357.71,79.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,88.36,346,87.62a.4.4,0,0,1-.15-.18.65.65,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l.43.24V84a1.12,1.12,0,0,0-.13-.53.84.84,0,0,0-.29-.36h0a.35.35,0,0,1-.15-.18.62.62,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0h0a1.5,1.5,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v3.27l.42.24a.44.44,0,0,1,.16.19.58.58,0,0,1,.06.26.23.23,0,0,1-.07.2A.12.12,0,0,1,347.24,88.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.73,85.79a.31.31,0,0,0,0,.13.15.15,0,0,0,.08.09l1.16.68a1.47,1.47,0,0,1,.6.72,2.43,2.43,0,0,1,.25,1.07v.65a1,1,0,0,1-.25.78.46.46,0,0,1-.6,0l-.84-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.45.45,0,0,1,.15.18.66.66,0,0,1,.06.27,1.12,1.12,0,0,0,.13.53.77.77,0,0,0,.3.37l.84.49a.24.24,0,0,0,.3,0,.5.5,0,0,0,.13-.39v-.65a1.19,1.19,0,0,0-.13-.54.79.79,0,0,0-.3-.36l-1.27-.74a.79.79,0,0,1-.3-.36,1.28,1.28,0,0,1-.12-.53V84.07a.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0l2.12,1.22a.45.45,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.8-1a.06.06,0,0,0-.08,0,.13.13,0,0,0,0,.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,88.42a.18.18,0,0,1,.06.08.26.26,0,0,1,0,.11v.52a.11.11,0,0,1,0,.08,0,0,0,0,1-.06,0l-.32-.18a.13.13,0,0,1-.06-.08.23.23,0,0,1,0-.11v-.51a.12.12,0,0,1,0-.09s0,0,.06,0Zm0,1.83a.18.18,0,0,1,.06.08.2.2,0,0,1,0,.11V91a.12.12,0,0,1,0,.09s0,0-.06,0l-.32-.18a.17.17,0,0,1-.06-.08.26.26,0,0,1,0-.11v-.52a.11.11,0,0,1,0-.08s0,0,.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,90.48l-.85-.49a.24.24,0,0,0-.3,0,.54.54,0,0,0-.12.39v.49a.28.28,0,0,0,0,.13.21.21,0,0,0,.08.1l1.8,1a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-2.12-1.22a.42.42,0,0,1-.15-.19.58.58,0,0,1-.06-.26v-1a1.07,1.07,0,0,1,.24-.78.47.47,0,0,1,.6,0l.85.49a.23.23,0,0,0,.3,0,.49.49,0,0,0,.13-.38v-.66a1.12,1.12,0,0,0-.13-.53.77.77,0,0,0-.3-.37l-.85-.49a.24.24,0,0,0-.3,0,.54.54,0,0,0-.12.39.28.28,0,0,1-.06.2.12.12,0,0,1-.15,0,.42.42,0,0,1-.15-.19.58.58,0,0,1-.06-.26,1.07,1.07,0,0,1,.24-.78.45.45,0,0,1,.6,0l.85.49a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v.65a1,1,0,0,1-.25.78A.45.45,0,0,1,354.32,90.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.44,90.24a.31.31,0,0,0,0,.13.15.15,0,0,0,.08.09l1.16.68a1.47,1.47,0,0,1,.6.72,2.46,2.46,0,0,1,.25,1.07v.65a1,1,0,0,1-.25.78.46.46,0,0,1-.6,0l-.85-.49a1.6,1.6,0,0,1-.59-.73,2.4,2.4,0,0,1-.25-1.07.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.45.45,0,0,1,.15.18.66.66,0,0,1,.06.27,1.12,1.12,0,0,0,.13.53.81.81,0,0,0,.29.37l.85.49a.24.24,0,0,0,.3,0,.5.5,0,0,0,.13-.39v-.65a1.19,1.19,0,0,0-.13-.54.79.79,0,0,0-.3-.36l-1.27-.74a.69.69,0,0,1-.3-.36,1.28,1.28,0,0,1-.12-.53V88.52a.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0l2.12,1.22a.42.42,0,0,1,.15.19.58.58,0,0,1,.06.26.24.24,0,0,1-.06.19.11.11,0,0,1-.15,0l-1.8-1a.08.08,0,0,0-.08,0,.13.13,0,0,0,0,.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,98.67,346,97.93a.43.43,0,0,1-.15-.17.66.66,0,0,1-.06-.27.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l.43.25V94.26a1.15,1.15,0,0,0-.13-.53.84.84,0,0,0-.29-.36h0a.42.42,0,0,1-.15-.19.58.58,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0h0a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v3.26l.42.25a.36.36,0,0,1,.16.18.66.66,0,0,1,.06.27.22.22,0,0,1-.07.19A.12.12,0,0,1,347.24,98.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.16,96.51,350,97a1.62,1.62,0,0,1,.61.73,2.54,2.54,0,0,1,.25,1.07v.65a1.07,1.07,0,0,1-.25.78.47.47,0,0,1-.61,0l-.84-.49a1.5,1.5,0,0,1-.6-.73,2.39,2.39,0,0,1-.25-1.06V95.37a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0L350,95a1.62,1.62,0,0,1,.61.73,2.57,2.57,0,0,1,.25,1.07.26.26,0,0,1-.07.19.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.84.84,0,0,0-.31-.37l-.84-.49a.24.24,0,0,0-.3,0,.5.5,0,0,0-.13.39v.83A.53.53,0,0,1,349.16,96.51Zm-.43,1.71a1.19,1.19,0,0,0,.13.54.79.79,0,0,0,.3.36l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39v-.65a1.24,1.24,0,0,0-.12-.53.84.84,0,0,0-.31-.37l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,98.73a.28.28,0,0,1,.06.08.27.27,0,0,1,0,.12v.51s0,.07,0,.08a0,0,0,0,1-.06,0l-.32-.19a.14.14,0,0,1-.06-.07.27.27,0,0,1,0-.12v-.51s0-.07,0-.08,0,0,.06,0Zm0,1.83a.28.28,0,0,1,.06.08.27.27,0,0,1,0,.12v.51a.11.11,0,0,1,0,.08,0,0,0,0,1-.06,0l-.32-.18a.13.13,0,0,1-.06-.08.2.2,0,0,1,0-.11v-.51a.12.12,0,0,1,0-.09,0,0,0,0,1,.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,102.76l-.85-.49a1.67,1.67,0,0,1-.6-.73,2.56,2.56,0,0,1-.24-1.07V97.86a1.07,1.07,0,0,1,.24-.78.47.47,0,0,1,.6,0l.85.49a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v2.61a1,1,0,0,1-.25.78A.46.46,0,0,1,354.32,102.76Zm-.85-1.15.85.49a.3.3,0,0,0,.2,0l-1.47-4v2.56a1.28,1.28,0,0,0,.12.53A.86.86,0,0,0,353.47,101.61Zm.85-3.42-.85-.49a.25.25,0,0,0-.2,0l1.48,4V99.08a1.29,1.29,0,0,0-.13-.53A.74.74,0,0,0,354.32,98.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,104.71l-.85-.49a1.51,1.51,0,0,1-.59-.72,2.46,2.46,0,0,1-.25-1.07V99.82a1,1,0,0,1,.25-.78.45.45,0,0,1,.59,0l.85.49a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v2.61a1,1,0,0,1-.25.78A.45.45,0,0,1,357.71,104.71Zm-.85-1.14.85.49a.25.25,0,0,0,.2,0l-1.47-4v2.55a1.19,1.19,0,0,0,.13.54A.84.84,0,0,0,356.86,103.57Zm.85-3.43-.85-.49a.24.24,0,0,0-.2,0l1.48,4V101a1.12,1.12,0,0,0-.13-.53A.77.77,0,0,0,357.71,100.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,109l-1.27-.73a.4.4,0,0,1-.15-.18.66.66,0,0,1-.06-.27.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l.43.24v-3.26a1.12,1.12,0,0,0-.13-.53.81.81,0,0,0-.29-.37h0a.39.39,0,0,1-.15-.18.66.66,0,0,1-.06-.27.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0h0a1.46,1.46,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v3.27l.42.24a.41.41,0,0,1,.16.18.66.66,0,0,1,.06.27.21.21,0,0,1-.07.19A.11.11,0,0,1,347.24,109Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.16,106.82l.84.49a1.62,1.62,0,0,1,.61.73,2.57,2.57,0,0,1,.25,1.07v.65a1.07,1.07,0,0,1-.25.78.48.48,0,0,1-.61,0l-.84-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.84.49a1.62,1.62,0,0,1,.61.73,2.57,2.57,0,0,1,.25,1.07.28.28,0,0,1-.07.2s-.09,0-.15,0a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26,1.32,1.32,0,0,0-.12-.54A.87.87,0,0,0,350,106l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v.83A.52.52,0,0,1,349.16,106.82Zm-.43,1.72a1.15,1.15,0,0,0,.13.53.74.74,0,0,0,.3.36l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39v-.66a1.28,1.28,0,0,0-.12-.53A.81.81,0,0,0,350,108l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,109.05a.18.18,0,0,1,.06.08.2.2,0,0,1,0,.11v.51a.12.12,0,0,1,0,.09h-.06l-.32-.18a.17.17,0,0,1-.06-.08.26.26,0,0,1,0-.11V109a.11.11,0,0,1,0-.08s0,0,.06,0Zm0,1.82.06.08a.27.27,0,0,1,0,.12v.51s0,.07,0,.08a0,0,0,0,1-.06,0l-.32-.18a.17.17,0,0,1-.06-.08.27.27,0,0,1,0-.12v-.51s0-.07,0-.08,0,0,.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.17,111.93v.32a1,1,0,0,1-.25.78.46.46,0,0,1-.6,0l-.85-.49a1.67,1.67,0,0,1-.6-.73,2.56,2.56,0,0,1-.24-1.07.27.27,0,0,1,.06-.19.12.12,0,0,1,.15,0,.47.47,0,0,1,.15.18.66.66,0,0,1,.06.27,1.24,1.24,0,0,0,.12.53.9.9,0,0,0,.3.37l.85.49a.24.24,0,0,0,.3,0,.54.54,0,0,0,.13-.39v-.33a1.25,1.25,0,0,0-.13-.53.77.77,0,0,0-.3-.37l-.21-.12a.35.35,0,0,1-.15-.18.62.62,0,0,1-.06-.26.28.28,0,0,1,.06-.2.11.11,0,0,1,.15,0l.21.12a.23.23,0,0,0,.3,0,.54.54,0,0,0,.13-.39v-.32a1.34,1.34,0,0,0-.13-.54.79.79,0,0,0-.3-.36l-.85-.49a.23.23,0,0,0-.3,0,.54.54,0,0,0-.12.39.24.24,0,0,1-.06.19.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.07,1.07,0,0,1,.24-.78.45.45,0,0,1,.6,0l.85.49a1.46,1.46,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06V110a1.44,1.44,0,0,1-.08.49.69.69,0,0,1-.21.32,2.49,2.49,0,0,1,.21.56A2.46,2.46,0,0,1,355.17,111.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,115l-.85-.49a1.6,1.6,0,0,1-.59-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.44.44,0,0,1,.59,0l.85.48a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v2.61a1,1,0,0,1-.25.78A.46.46,0,0,1,357.71,115Zm-.85-1.15.85.49a.25.25,0,0,0,.2,0l-1.47-4V113a1.15,1.15,0,0,0,.13.53A.78.78,0,0,0,356.86,113.88Zm.85-3.42-.85-.49a.29.29,0,0,0-.2,0l1.48,4v-2.56a1.18,1.18,0,0,0-.13-.53A.74.74,0,0,0,357.71,110.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,119.3l-1.27-.74a.4.4,0,0,1-.15-.18.62.62,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l.43.24v-3.26a1.12,1.12,0,0,0-.13-.53A.84.84,0,0,0,346,114h0a.35.35,0,0,1-.15-.18.62.62,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0h0a1.55,1.55,0,0,1,.6.73,2.4,2.4,0,0,1,.25,1.07v3.26l.42.24a.44.44,0,0,1,.16.19.65.65,0,0,1,.06.26.24.24,0,0,1-.07.2A.12.12,0,0,1,347.24,119.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.75,118.22l-1,2.22a0,0,0,0,0,0,0l0,0,0,0s0,0,0,0l0,0,0,0h0l0,0a.34.34,0,0,1-.15-.16.58.58,0,0,1-.06-.28.53.53,0,0,1,.1-.27c.31-.71.6-1.42.87-2.11a1.15,1.15,0,0,0,.06-.25c0-.1,0-.19,0-.25v-.1a1.19,1.19,0,0,0-.13-.54.79.79,0,0,0-.3-.36l-.42-.24-.21-.13-.85-.49a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l.85.49.21.12.42.25a1.5,1.5,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06,3.49,3.49,0,0,1,0,.44A2.92,2.92,0,0,1,350.75,118.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,119.36a.18.18,0,0,1,.06.08.26.26,0,0,1,0,.11v.52a.11.11,0,0,1,0,.08,0,0,0,0,1-.06,0l-.32-.18a.13.13,0,0,1-.06-.08.23.23,0,0,1,0-.11v-.51a.12.12,0,0,1,0-.09,0,0,0,0,1,.06,0Zm0,1.83a.18.18,0,0,1,.06.08.2.2,0,0,1,0,.11v.51a.12.12,0,0,1,0,.09,0,0,0,0,1-.06,0l-.32-.18a.13.13,0,0,1-.06-.08.26.26,0,0,1,0-.11v-.52a.11.11,0,0,1,0-.08s0,0,.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,123.38l-.85-.49a1.62,1.62,0,0,1-.6-.73,2.52,2.52,0,0,1-.24-1.06v-2.61a1.07,1.07,0,0,1,.24-.78.47.47,0,0,1,.6,0l.85.49a1.55,1.55,0,0,1,.6.73,2.4,2.4,0,0,1,.25,1.07v2.61a1,1,0,0,1-.25.77A.44.44,0,0,1,354.32,123.38Zm-.85-1.14.85.49a.25.25,0,0,0,.2,0l-1.47-4v2.55a1.32,1.32,0,0,0,.12.54A.93.93,0,0,0,353.47,122.24Zm.85-3.43-.85-.49a.24.24,0,0,0-.2,0l1.48,4v-2.55a1.25,1.25,0,0,0-.13-.53A.77.77,0,0,0,354.32,118.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,125.34l-.85-.49a1.54,1.54,0,0,1-.59-.73,2.39,2.39,0,0,1-.25-1.06v-2.62a1,1,0,0,1,.25-.77.44.44,0,0,1,.59,0l.85.49a1.5,1.5,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v2.61a1,1,0,0,1-.25.78A.46.46,0,0,1,357.71,125.34Zm-.85-1.14.85.49a.25.25,0,0,0,.2,0l-1.47-4v2.55a1.12,1.12,0,0,0,.13.53A.81.81,0,0,0,356.86,124.2Zm.85-3.43-.85-.49a.24.24,0,0,0-.2,0l1.48,4v-2.55a1.12,1.12,0,0,0-.13-.53A.77.77,0,0,0,357.71,120.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.24,129.61l-1.27-.73a.51.51,0,0,1-.15-.19.58.58,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l.43.25V125.2a1.15,1.15,0,0,0-.13-.53.84.84,0,0,0-.29-.36h0a.42.42,0,0,1-.15-.19.58.58,0,0,1-.06-.26.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0h0a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v3.26l.42.25a.36.36,0,0,1,.16.18.66.66,0,0,1,.06.27.22.22,0,0,1-.07.19A.12.12,0,0,1,347.24,129.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.75,128.53l-1,2.22s0,0,0,0l0,0s0,0,0,0,0,0,0,0l0,0,0,0h-.08a.42.42,0,0,1-.15-.17.55.55,0,0,1-.06-.28.53.53,0,0,1,.1-.27q.46-1.06.87-2.1a1.31,1.31,0,0,0,.06-.25c0-.11,0-.19,0-.26v-.1a1.12,1.12,0,0,0-.13-.53.77.77,0,0,0-.3-.37l-.42-.24-.21-.12-.85-.49a.42.42,0,0,1-.15-.19.58.58,0,0,1-.06-.26.3.3,0,0,1,.06-.2.12.12,0,0,1,.15,0l.85.49.21.13.42.24a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07,3.34,3.34,0,0,1,0,.43A2.44,2.44,0,0,1,350.75,128.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,129.67a.28.28,0,0,1,.06.08.27.27,0,0,1,0,.12v.51s0,.07,0,.08a0,0,0,0,1-.06,0l-.32-.18a.24.24,0,0,1-.06-.08.27.27,0,0,1,0-.12v-.51s0-.07,0-.08,0,0,.06,0Zm0,1.83a.28.28,0,0,1,.06.08.26.26,0,0,1,0,.11v.52a.1.1,0,0,1,0,.08,0,0,0,0,1-.06,0l-.32-.19a.13.13,0,0,1-.06-.08.2.2,0,0,1,0-.11v-.51a.12.12,0,0,1,0-.09,0,0,0,0,1,.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.11,133.57l-1.28-.73a.54.54,0,0,1-.14-.18.54.54,0,0,1-.07-.27.26.26,0,0,1,.07-.2.11.11,0,0,1,.14,0l.43.25v-3.26a1.21,1.21,0,0,0-.12-.53.83.83,0,0,0-.3-.37h0a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27.3.3,0,0,1,.06-.2.12.12,0,0,1,.15,0h0a1.55,1.55,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v3.26l.43.25a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.22.22,0,0,1-.07.19A.11.11,0,0,1,354.11,133.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.59,131a.35.35,0,0,0,0,.14.36.36,0,0,0,.08.09l1.17.67a1.6,1.6,0,0,1,.59.73,2.43,2.43,0,0,1,.25,1.07v.65a1,1,0,0,1-.25.78.44.44,0,0,1-.59,0l-.85-.48a1.55,1.55,0,0,1-.6-.73,2.46,2.46,0,0,1-.25-1.07.28.28,0,0,1,.06-.2s.09,0,.15,0a.35.35,0,0,1,.15.18.58.58,0,0,1,.06.26,1.34,1.34,0,0,0,.13.54.79.79,0,0,0,.3.36l.85.49a.21.21,0,0,0,.29,0,.5.5,0,0,0,.13-.39v-.65a1.12,1.12,0,0,0-.13-.53.81.81,0,0,0-.29-.37l-1.28-.73a.9.9,0,0,1-.3-.37,1.24,1.24,0,0,1-.12-.53v-1.63a.28.28,0,0,1,.06-.2s.09,0,.15,0l2.12,1.22a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.8-1a.06.06,0,0,0-.08,0,.15.15,0,0,0,0,.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,112a.28.28,0,0,1-.06-.08.34.34,0,0,1,0-.1l.07-.49a.15.15,0,0,1,0-.08.08.08,0,0,1,.07,0l2,1.17a.11.11,0,0,1,.06.07.21.21,0,0,1,0,.11l-.07.49a.08.08,0,0,1,0,.07s0,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,113.5a.16.16,0,0,1-.05-.08.18.18,0,0,1,0-.1l.07-.49a.15.15,0,0,1,0-.08.11.11,0,0,1,.08,0l2,1.17a.11.11,0,0,1,.06.07.21.21,0,0,1,0,.11l-.07.49a.07.07,0,0,1,0,.07s0,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,116.66a.11.11,0,0,1-.06-.07.21.21,0,0,1,0-.11l.07-.48a.09.09,0,0,1,0-.08.08.08,0,0,1,.07,0l2,1.16a.16.16,0,0,1,0,.08.2.2,0,0,1,0,.11l-.07.48a.15.15,0,0,1,0,.08.08.08,0,0,1-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,118.15a.11.11,0,0,1-.06-.07.21.21,0,0,1,0-.11l.07-.48a.1.1,0,0,1,0-.08h.07l2,1.16a.28.28,0,0,1,.06.08.37.37,0,0,1,0,.11l-.07.48a.15.15,0,0,1,0,.08.08.08,0,0,1-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,123.93a.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.9.9,0,0,0-.3-.37l-.85-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.12,1.12,0,0,0,.13.53.77.77,0,0,0,.3.37l.85.49a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.54.54,0,0,1,.07.26,1,1,0,0,1-.25.78.45.45,0,0,1-.6,0l-.85-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.45.45,0,0,1,.6,0l.85.49a1.62,1.62,0,0,1,.6.73,2.53,2.53,0,0,1,.25,1.06A.23.23,0,0,1,433.1,123.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,129.52a.11.11,0,0,1-.15,0,.35.35,0,0,1-.15-.18.64.64,0,0,1-.07-.27v-1.46a.35.35,0,0,0,0-.14.22.22,0,0,0-.07-.09l-1.49-.86a.06.06,0,0,0-.07,0,.13.13,0,0,0,0,.1v1.46a.27.27,0,0,1-.06.2.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.68.68,0,0,1-.07-.27v-3.59a1.07,1.07,0,0,1,.25-.78.47.47,0,0,1,.6,0l.85.49a1.61,1.61,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v3.59A.24.24,0,0,1,436.58,129.52Zm-.37-4a1.28,1.28,0,0,0-.12-.53.74.74,0,0,0-.3-.36l-.85-.49a.24.24,0,0,0-.3,0,.55.55,0,0,0-.12.39v1.15a.31.31,0,0,0,0,.13.23.23,0,0,0,.07.09l1.49.86a0,0,0,0,0,.07,0,.12.12,0,0,0,0-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.9,131.54a.55.55,0,0,1-.18-.27L438,126.56v3.55a.26.26,0,0,1-.07.2.12.12,0,0,1-.15,0,.42.42,0,0,1-.15-.19.62.62,0,0,1-.06-.26V125.3a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.52.52,0,0,1,.19.27l1.72,4.72v-3.56a.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.54.54,0,0,1,.07.27v4.57a.27.27,0,0,1-.07.19A.12.12,0,0,1,439.9,131.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,130a.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.84.84,0,0,0-.31-.37l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.12,1.12,0,0,0,.13.53.77.77,0,0,0,.3.37l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27,1,1,0,0,1-.24.77.47.47,0,0,1-.61,0l-.84-.49a1.55,1.55,0,0,1-.6-.73,2.4,2.4,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.77.44.44,0,0,1,.6,0l.84.49a1.57,1.57,0,0,1,.61.73,2.53,2.53,0,0,1,.24,1.07A.25.25,0,0,1,443.53,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,131l-1.81-1a.06.06,0,0,0-.07,0,.13.13,0,0,0,0,.1v1.3a.28.28,0,0,0,0,.13.2.2,0,0,0,.07.1l1.38.79a.39.39,0,0,1,.15.18.66.66,0,0,1,.06.27.28.28,0,0,1-.06.2.12.12,0,0,1-.15,0l-1.38-.79s-.05,0-.07,0a.15.15,0,0,0,0,.1v1.31a.35.35,0,0,0,0,.13.22.22,0,0,0,.07.09l1.81,1a.45.45,0,0,1,.14.18.54.54,0,0,1,.07.27.24.24,0,0,1-.07.2.11.11,0,0,1-.14,0l-2.12-1.22a.39.39,0,0,1-.15-.18.54.54,0,0,1-.07-.27v-4.57a.22.22,0,0,1,.07-.19.11.11,0,0,1,.15,0l2.12,1.22a.45.45,0,0,1,.14.18.54.54,0,0,1,.07.27.24.24,0,0,1-.07.2A.11.11,0,0,1,446.86,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,137.56l-2.12-1.22a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.58.58,0,0,1,.06.26v4.08a.35.35,0,0,0,0,.14.36.36,0,0,0,.08.09l1.8,1a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.12.12,0,0,1,450.33,137.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,135l-1.8-1a.06.06,0,0,0-.08,0,.15.15,0,0,0,0,.1v1.31a.35.35,0,0,0,0,.13.24.24,0,0,0,.08.09l1.37.8a.35.35,0,0,1,.15.18.68.68,0,0,1,.07.27.26.26,0,0,1-.07.19.12.12,0,0,1-.15,0l-1.37-.8a.08.08,0,0,0-.08,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13.15.15,0,0,0,.08.09l1.8,1a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-2.12-1.23a.35.35,0,0,1-.15-.18.6.6,0,0,1-.06-.27v-4.56a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l2.12,1.23a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.12.12,0,0,1,453.81,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,141.21l-1.49-.86a.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l1.49.86a1.59,1.59,0,0,1,.6.72,2.57,2.57,0,0,1,.25,1.07v2.61a1.07,1.07,0,0,1-.25.78A.47.47,0,0,1,456.65,141.21Zm.42-3.67A1.32,1.32,0,0,0,457,137a.85.85,0,0,0-.3-.36l-1.17-.67s-.05,0-.07,0a.13.13,0,0,0,0,.1v3.59a.31.31,0,0,0,0,.13.17.17,0,0,0,.07.09l1.17.67a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,134.24a.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.9.9,0,0,0-.3-.37l-.85-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.19,1.19,0,0,0,.13.54.79.79,0,0,0,.3.36l.85.49a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.54.54,0,0,1,.07.27,1.07,1.07,0,0,1-.25.78.45.45,0,0,1-.6,0l-.85-.49a1.5,1.5,0,0,1-.6-.73,2.39,2.39,0,0,1-.25-1.06v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.85.49a1.67,1.67,0,0,1,.6.73,2.57,2.57,0,0,1,.25,1.07A.22.22,0,0,1,433.1,134.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,139.84a.11.11,0,0,1-.15,0,.35.35,0,0,1-.15-.18.59.59,0,0,1-.07-.26v-1.47a.28.28,0,0,0,0-.13.2.2,0,0,0-.07-.1l-1.49-.85a0,0,0,0,0-.07,0,.15.15,0,0,0,0,.1v1.47a.24.24,0,0,1-.06.19.11.11,0,0,1-.15,0,.35.35,0,0,1-.15-.18.68.68,0,0,1-.07-.27v-3.59a1.07,1.07,0,0,1,.25-.78.45.45,0,0,1,.6,0l.85.49a1.56,1.56,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v3.59A.28.28,0,0,1,436.58,139.84Zm-.37-4a1.32,1.32,0,0,0-.12-.54.79.79,0,0,0-.3-.36l-.85-.49a.23.23,0,0,0-.3,0,.54.54,0,0,0-.12.39V136a.31.31,0,0,0,0,.13.17.17,0,0,0,.07.09l1.49.86s.05,0,.07,0a.15.15,0,0,0,0-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.9,141.85a.55.55,0,0,1-.18-.27L438,136.87v3.56a.24.24,0,0,1-.07.19.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.56a.27.27,0,0,1,.06-.2.11.11,0,0,1,.15,0,.45.45,0,0,1,.19.27l1.72,4.71v-3.55a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.48.48,0,0,1,.07.26v4.57a.26.26,0,0,1-.07.19A.11.11,0,0,1,439.9,141.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,140.26a.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.63.63,0,0,1-.06-.27,1.28,1.28,0,0,0-.12-.53.84.84,0,0,0-.31-.37l-.84-.49a.24.24,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.19,1.19,0,0,0,.13.54.79.79,0,0,0,.3.36l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27,1.07,1.07,0,0,1-.24.78.47.47,0,0,1-.61,0l-.84-.49a1.46,1.46,0,0,1-.6-.73,2.39,2.39,0,0,1-.25-1.06V138.6a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.84.49a1.62,1.62,0,0,1,.61.73,2.56,2.56,0,0,1,.24,1.07A.25.25,0,0,1,443.53,140.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,141.3l-1.81-1s-.05,0-.07,0a.15.15,0,0,0,0,.1v1.31a.35.35,0,0,0,0,.13.22.22,0,0,0,.07.09l1.38.79a.42.42,0,0,1,.15.19.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.38-.8a.06.06,0,0,0-.07,0,.12.12,0,0,0,0,.09V144a.31.31,0,0,0,0,.13s0,.08.07.09l1.81,1a.49.49,0,0,1,.14.19.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19.11.11,0,0,1-.14,0l-2.12-1.23a.35.35,0,0,1-.15-.18.5.5,0,0,1-.07-.27v-4.56a.24.24,0,0,1,.07-.2.12.12,0,0,1,.15,0l2.12,1.22a.49.49,0,0,1,.14.19.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19A.11.11,0,0,1,446.86,141.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,147.87l-2.12-1.22a.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27V146a.31.31,0,0,0,0,.13.36.36,0,0,0,.08.09l1.8,1a.42.42,0,0,1,.15.19.58.58,0,0,1,.06.26.28.28,0,0,1-.06.2S450.39,147.91,450.33,147.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,145.31l-1.8-1a.08.08,0,0,0-.08,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13.15.15,0,0,0,.08.09l1.37.8a.35.35,0,0,1,.15.18.68.68,0,0,1,.07.27.26.26,0,0,1-.07.19.11.11,0,0,1-.15,0l-1.37-.79a.06.06,0,0,0-.08,0,.13.13,0,0,0,0,.1V148a.35.35,0,0,0,0,.14.24.24,0,0,0,.08.09l1.8,1a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-2.12-1.22a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l2.12,1.23a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.12.12,0,0,1,453.81,145.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,151.52l-1.49-.86a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26v-4.57a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l1.49.86a1.62,1.62,0,0,1,.6.73,2.53,2.53,0,0,1,.25,1.06v2.61a1,1,0,0,1-.25.78A.45.45,0,0,1,456.65,151.52Zm.42-3.67a1.24,1.24,0,0,0-.12-.53.83.83,0,0,0-.3-.37l-1.17-.67s-.05,0-.07,0a.15.15,0,0,0,0,.1V150a.31.31,0,0,0,0,.13c0,.05,0,.08.07.09l1.17.68a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,144.56a.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26,1.32,1.32,0,0,0-.12-.54.93.93,0,0,0-.3-.36l-.85-.49a.24.24,0,0,0-.3,0,.51.51,0,0,0-.13.4v2.61a1.15,1.15,0,0,0,.13.53.74.74,0,0,0,.3.36l.85.49a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.48.48,0,0,1,.07.26,1.07,1.07,0,0,1-.25.78.47.47,0,0,1-.6,0l-.85-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.85.49a1.67,1.67,0,0,1,.6.73,2.57,2.57,0,0,1,.25,1.07A.24.24,0,0,1,433.1,144.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,150.15a.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.68.68,0,0,1-.07-.27v-1.47a.31.31,0,0,0,0-.13c0-.05,0-.08-.07-.09l-1.49-.86a0,0,0,0,0-.07,0,.12.12,0,0,0,0,.09v1.47a.28.28,0,0,1-.06.2.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.68.68,0,0,1-.07-.27V144.9a1.07,1.07,0,0,1,.25-.78.47.47,0,0,1,.6,0l.85.49a1.61,1.61,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07V150A.25.25,0,0,1,436.58,150.15Zm-.37-4a1.24,1.24,0,0,0-.12-.53.77.77,0,0,0-.3-.37l-.85-.49a.24.24,0,0,0-.3,0,.54.54,0,0,0-.12.39v1.14a.29.29,0,0,0,.1.23l1.49.85s.05,0,.07,0a.13.13,0,0,0,0-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.9,152.17a.55.55,0,0,1-.18-.27L438,147.18v3.56a.22.22,0,0,1-.07.19.11.11,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.56a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.45.45,0,0,1,.19.27l1.72,4.72v-3.56a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.51.51,0,0,1,.07.26V152a.28.28,0,0,1-.07.2A.12.12,0,0,1,439.9,152.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,150.58s-.09,0-.15,0a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26,1.32,1.32,0,0,0-.12-.54.87.87,0,0,0-.31-.36l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.15,1.15,0,0,0,.13.53.74.74,0,0,0,.3.36l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.62.62,0,0,1,.06.26,1.07,1.07,0,0,1-.24.78.48.48,0,0,1-.61,0l-.84-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.84.5a1.54,1.54,0,0,1,.61.72,2.6,2.6,0,0,1,.24,1.07A.28.28,0,0,1,443.53,150.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,151.61l-1.81-1a0,0,0,0,0-.07,0,.12.12,0,0,0,0,.09V152a.31.31,0,0,0,0,.13s0,.08.07.09l1.38.8a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.38-.79s-.05,0-.07,0a.13.13,0,0,0,0,.1v1.3a.35.35,0,0,0,0,.14.22.22,0,0,0,.07.09l1.81,1a.39.39,0,0,1,.14.18.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19.11.11,0,0,1-.14,0L444.74,155a.45.45,0,0,1-.15-.18.54.54,0,0,1-.07-.27v-4.57a.26.26,0,0,1,.07-.2.12.12,0,0,1,.15,0l2.12,1.23a.39.39,0,0,1,.14.18.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19A.11.11,0,0,1,446.86,151.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,158.19,448.21,157a.35.35,0,0,1-.15-.18.6.6,0,0,1-.06-.27V152a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.45.45,0,0,1,.15.18.66.66,0,0,1,.06.27v4.08a.31.31,0,0,0,0,.13s.05.08.08.09l1.8,1a.42.42,0,0,1,.15.19.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.12.12,0,0,1,450.33,158.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,155.63l-1.8-1a.06.06,0,0,0-.08,0,.13.13,0,0,0,0,.1V156a.35.35,0,0,0,0,.14.24.24,0,0,0,.08.09l1.37.79a.42.42,0,0,1,.15.19.59.59,0,0,1,.07.26.28.28,0,0,1-.07.2.12.12,0,0,1-.15,0l-1.37-.8a.05.05,0,0,0-.08,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13.24.24,0,0,0,.08.09l1.8,1a.46.46,0,0,1,.15.18.66.66,0,0,1,.06.27.28.28,0,0,1-.06.2.12.12,0,0,1-.15,0L451.69,159a.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27V154a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l2.12,1.22a.51.51,0,0,1,.15.19.58.58,0,0,1,.06.26.28.28,0,0,1-.06.2A.12.12,0,0,1,453.81,155.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,161.83l-1.49-.85a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27V156a.25.25,0,0,1,.06-.19c0-.05.09-.05.15,0l1.49.85a1.67,1.67,0,0,1,.6.73,2.57,2.57,0,0,1,.25,1.07V161a1.07,1.07,0,0,1-.25.78A.45.45,0,0,1,456.65,161.83Zm.42-3.67a1.24,1.24,0,0,0-.12-.53.83.83,0,0,0-.3-.37l-1.17-.67a.06.06,0,0,0-.07,0,.12.12,0,0,0,0,.09v3.59a.35.35,0,0,0,0,.14.22.22,0,0,0,.07.09l1.17.67a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,154.87a.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.9.9,0,0,0-.3-.37l-.85-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.12,1.12,0,0,0,.13.53.77.77,0,0,0,.3.37l.85.49a.24.24,0,0,0,.3,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2s.09,0,.15,0a.35.35,0,0,1,.15.18.54.54,0,0,1,.07.26,1,1,0,0,1-.25.78.45.45,0,0,1-.6,0l-.85-.49a1.55,1.55,0,0,1-.6-.73,2.4,2.4,0,0,1-.25-1.07V153.2a1,1,0,0,1,.25-.78.45.45,0,0,1,.6,0l.85.49a1.62,1.62,0,0,1,.6.73,2.53,2.53,0,0,1,.25,1.06A.23.23,0,0,1,433.1,154.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,160.47a.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.6.6,0,0,1-.07-.27v-1.46a.35.35,0,0,0,0-.14.22.22,0,0,0-.07-.09l-1.49-.86a.06.06,0,0,0-.07,0,.13.13,0,0,0,0,.1v1.47a.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.68.68,0,0,1-.07-.27v-3.59a1.07,1.07,0,0,1,.25-.78.47.47,0,0,1,.6,0l.85.49a1.61,1.61,0,0,1,.6.73,2.43,2.43,0,0,1,.25,1.07v3.59A.28.28,0,0,1,436.58,160.47Zm-.37-4a1.28,1.28,0,0,0-.12-.53.74.74,0,0,0-.3-.36l-.85-.49a.24.24,0,0,0-.3,0,.55.55,0,0,0-.12.4v1.14a.31.31,0,0,0,0,.13.35.35,0,0,0,.07.09l1.49.86a.06.06,0,0,0,.07,0,.12.12,0,0,0,0-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.9,162.48a.55.55,0,0,1-.18-.27L438,157.5v3.55a.24.24,0,0,1-.07.2.12.12,0,0,1-.15,0,.42.42,0,0,1-.15-.19.62.62,0,0,1-.06-.26v-4.57a.3.3,0,0,1,.06-.2.12.12,0,0,1,.15,0,.52.52,0,0,1,.19.27l1.72,4.72v-3.56a.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.54.54,0,0,1,.07.27v4.57a.27.27,0,0,1-.07.19A.12.12,0,0,1,439.9,162.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,160.89a.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.84.84,0,0,0-.31-.37l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.12,1.12,0,0,0,.13.53.77.77,0,0,0,.3.37l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27,1.07,1.07,0,0,1-.24.78.48.48,0,0,1-.61,0l-.84-.49a1.5,1.5,0,0,1-.6-.73,2.39,2.39,0,0,1-.25-1.06v-2.62a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.84.49a1.57,1.57,0,0,1,.61.73,2.52,2.52,0,0,1,.24,1.06A.27.27,0,0,1,443.53,160.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,161.93l-1.81-1.05a.06.06,0,0,0-.07,0,.13.13,0,0,0,0,.1v1.3a.35.35,0,0,0,0,.14.22.22,0,0,0,.07.09l1.38.79a.39.39,0,0,1,.15.18.66.66,0,0,1,.06.27.28.28,0,0,1-.06.2s-.09,0-.15,0l-1.38-.79s-.05,0-.07,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13.22.22,0,0,0,.07.09l1.81,1a.39.39,0,0,1,.14.18.54.54,0,0,1,.07.27.24.24,0,0,1-.07.2.11.11,0,0,1-.14,0l-2.12-1.22a.35.35,0,0,1-.15-.18.54.54,0,0,1-.07-.27v-4.57a.22.22,0,0,1,.07-.19.11.11,0,0,1,.15,0l2.12,1.22a.43.43,0,0,1,.14.19.48.48,0,0,1,.07.26.24.24,0,0,1-.07.2A.11.11,0,0,1,446.86,161.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,168.5l-2.12-1.22a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.58.58,0,0,1,.06.26v4.08a.35.35,0,0,0,0,.14.36.36,0,0,0,.08.09l1.8,1a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.11.11,0,0,1,450.33,168.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,165.94l-1.8-1a.06.06,0,0,0-.08,0,.15.15,0,0,0,0,.1v1.31a.35.35,0,0,0,0,.13.24.24,0,0,0,.08.09l1.37.8a.35.35,0,0,1,.15.18.68.68,0,0,1,.07.27.26.26,0,0,1-.07.19.12.12,0,0,1-.15,0l-1.37-.8a.08.08,0,0,0-.08,0,.13.13,0,0,0,0,.1v1.3a.28.28,0,0,0,0,.13.15.15,0,0,0,.08.09l1.8,1a.51.51,0,0,1,.15.19.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-2.12-1.23a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26v-4.57a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l2.12,1.23a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.12.12,0,0,1,453.81,165.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,172.15l-1.49-.86a.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l1.49.86a1.59,1.59,0,0,1,.6.72,2.61,2.61,0,0,1,.25,1.07v2.61a1.07,1.07,0,0,1-.25.78A.47.47,0,0,1,456.65,172.15Zm.42-3.67a1.32,1.32,0,0,0-.12-.54.85.85,0,0,0-.3-.36l-1.17-.67s-.05,0-.07,0a.13.13,0,0,0,0,.1v3.59a.31.31,0,0,0,0,.13.22.22,0,0,0,.07.09l1.17.68a.24.24,0,0,0,.3,0,.54.54,0,0,0,.12-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,165.18a.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.24,1.24,0,0,0-.12-.53.9.9,0,0,0-.3-.37l-.85-.49a.24.24,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.19,1.19,0,0,0,.13.54.79.79,0,0,0,.3.36l.85.49a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.54.54,0,0,1,.07.27,1.07,1.07,0,0,1-.25.78.45.45,0,0,1-.6,0l-.85-.49a1.5,1.5,0,0,1-.6-.73,2.39,2.39,0,0,1-.25-1.06v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.85.49a1.67,1.67,0,0,1,.6.73,2.57,2.57,0,0,1,.25,1.07A.22.22,0,0,1,433.1,165.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,170.78a.12.12,0,0,1-.15,0,.42.42,0,0,1-.15-.19.59.59,0,0,1-.07-.26v-1.47a.28.28,0,0,0,0-.13.2.2,0,0,0-.07-.1l-1.49-.85a0,0,0,0,0-.07,0,.15.15,0,0,0,0,.1v1.47a.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0,.35.35,0,0,1-.15-.18.64.64,0,0,1-.07-.27v-3.59a1.07,1.07,0,0,1,.25-.78.45.45,0,0,1,.6,0l.85.49a1.56,1.56,0,0,1,.6.73,2.39,2.39,0,0,1,.25,1.06v3.59A.28.28,0,0,1,436.58,170.78Zm-.37-4a1.32,1.32,0,0,0-.12-.54.79.79,0,0,0-.3-.36l-.85-.49a.23.23,0,0,0-.3,0,.54.54,0,0,0-.12.39v1.14a.31.31,0,0,0,0,.13.29.29,0,0,0,.07.1l1.49.85s.05,0,.07,0a.15.15,0,0,0,0-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.9,172.79a.55.55,0,0,1-.18-.27L438,167.81v3.56a.24.24,0,0,1-.07.19.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.56a.28.28,0,0,1,.06-.2.11.11,0,0,1,.15,0,.45.45,0,0,1,.19.27l1.72,4.72v-3.56a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.48.48,0,0,1,.07.26v4.57a.26.26,0,0,1-.07.19A.11.11,0,0,1,439.9,172.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,171.2a.11.11,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27,1.28,1.28,0,0,0-.12-.53.84.84,0,0,0-.31-.37l-.84-.49a.24.24,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.19,1.19,0,0,0,.13.54.79.79,0,0,0,.3.36l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27,1.07,1.07,0,0,1-.24.78.47.47,0,0,1-.61,0l-.84-.49a1.47,1.47,0,0,1-.6-.72,2.46,2.46,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.84.49a1.62,1.62,0,0,1,.61.73,2.56,2.56,0,0,1,.24,1.07A.24.24,0,0,1,443.53,171.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,172.24l-1.81-1s-.05,0-.07,0a.15.15,0,0,0,0,.1v1.3a.35.35,0,0,0,0,.14.22.22,0,0,0,.07.09l1.38.8a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.38-.8a.06.06,0,0,0-.07,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13s0,.08.07.09l1.81,1a.49.49,0,0,1,.14.19.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19.11.11,0,0,1-.14,0l-2.12-1.23a.35.35,0,0,1-.15-.18.5.5,0,0,1-.07-.27v-4.56a.24.24,0,0,1,.07-.2.12.12,0,0,1,.15,0l2.12,1.23a.39.39,0,0,1,.14.18.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19A.11.11,0,0,1,446.86,172.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,178.81l-2.12-1.22a.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.12.12,0,0,1,.15,0,.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27v4.08a.31.31,0,0,0,0,.13.36.36,0,0,0,.08.09l1.8,1a.45.45,0,0,1,.15.18.66.66,0,0,1,.06.27.28.28,0,0,1-.06.2S450.39,178.85,450.33,178.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,176.25l-1.8-1a.08.08,0,0,0-.08,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13.15.15,0,0,0,.08.09l1.37.8a.35.35,0,0,1,.15.18.68.68,0,0,1,.07.27.24.24,0,0,1-.07.19.11.11,0,0,1-.15,0L452,177.5a.06.06,0,0,0-.08,0,.13.13,0,0,0,0,.1v1.3a.35.35,0,0,0,0,.14.24.24,0,0,0,.08.09l1.8,1a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-2.12-1.22a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19s.09,0,.15,0l2.12,1.22a.4.4,0,0,1,.15.18.66.66,0,0,1,.06.27.24.24,0,0,1-.06.19A.11.11,0,0,1,453.81,176.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,182.46l-1.49-.86a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26v-4.57a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0l1.49.86a1.62,1.62,0,0,1,.6.73,2.53,2.53,0,0,1,.25,1.06v2.61a1.06,1.06,0,0,1-.25.78A.45.45,0,0,1,456.65,182.46Zm.42-3.67a1.24,1.24,0,0,0-.12-.53.83.83,0,0,0-.3-.37l-1.17-.67s-.05,0-.07,0a.15.15,0,0,0,0,.1v3.59a.28.28,0,0,0,0,.13.2.2,0,0,0,.07.1l1.17.67a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,175.5s-.09,0-.15,0a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26,1.32,1.32,0,0,0-.12-.54.93.93,0,0,0-.3-.36l-.85-.49a.23.23,0,0,0-.3,0,.51.51,0,0,0-.13.4v2.61a1.15,1.15,0,0,0,.13.53.79.79,0,0,0,.3.36l.85.49a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.48.48,0,0,1,.07.26,1.07,1.07,0,0,1-.25.78.47.47,0,0,1-.6,0l-.85-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.46.46,0,0,1,.6,0l.85.49a1.67,1.67,0,0,1,.6.73,2.61,2.61,0,0,1,.25,1.07A.24.24,0,0,1,433.1,175.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,181.09a.12.12,0,0,1-.15,0,.39.39,0,0,1-.15-.18.68.68,0,0,1-.07-.27v-1.47a.31.31,0,0,0,0-.13s0-.08-.07-.09l-1.49-.86a0,0,0,0,0-.07,0,.12.12,0,0,0,0,.09v1.47a.28.28,0,0,1-.06.2.12.12,0,0,1-.15,0,.45.45,0,0,1-.15-.18.68.68,0,0,1-.07-.27v-3.59a1.07,1.07,0,0,1,.25-.78.47.47,0,0,1,.6,0l.85.49a1.61,1.61,0,0,1,.6.73,2.4,2.4,0,0,1,.25,1.07v3.59A.25.25,0,0,1,436.58,181.09Zm-.37-4a1.24,1.24,0,0,0-.12-.53.77.77,0,0,0-.3-.37l-.85-.49a.24.24,0,0,0-.3,0,.54.54,0,0,0-.12.39v1.14a.29.29,0,0,0,.1.23l1.49.85s.05,0,.07,0a.13.13,0,0,0,0-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.9,183.11a.55.55,0,0,1-.18-.27L438,178.13v3.55a.22.22,0,0,1-.07.19.11.11,0,0,1-.15,0,.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.56a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.52.52,0,0,1,.19.27l1.72,4.72v-3.56a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0,.35.35,0,0,1,.15.18.54.54,0,0,1,.07.26v4.57a.28.28,0,0,1-.07.2A.12.12,0,0,1,439.9,183.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.53,181.52s-.09,0-.15,0a.35.35,0,0,1-.15-.18.58.58,0,0,1-.06-.26,1.32,1.32,0,0,0-.12-.54.87.87,0,0,0-.31-.36l-.84-.49a.23.23,0,0,0-.3,0,.5.5,0,0,0-.13.39v2.61a1.15,1.15,0,0,0,.13.53.69.69,0,0,0,.3.36l.84.49a.24.24,0,0,0,.31,0,.54.54,0,0,0,.12-.39.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.42.42,0,0,1,.15.19.62.62,0,0,1,.06.26,1.07,1.07,0,0,1-.24.78.48.48,0,0,1-.61,0l-.84-.49a1.55,1.55,0,0,1-.6-.73,2.43,2.43,0,0,1-.25-1.07v-2.61a1,1,0,0,1,.25-.78.45.45,0,0,1,.6,0l.84.48a1.6,1.6,0,0,1,.61.74,2.52,2.52,0,0,1,.24,1.06A.28.28,0,0,1,443.53,181.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,182.55l-1.81-1a0,0,0,0,0-.07,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13s0,.08.07.09l1.38.8a.35.35,0,0,1,.15.18.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19.12.12,0,0,1-.15,0l-1.38-.79s-.05,0-.07,0a.13.13,0,0,0,0,.1v1.3a.35.35,0,0,0,0,.14.22.22,0,0,0,.07.09l1.81,1a.39.39,0,0,1,.14.18.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19.11.11,0,0,1-.14,0l-2.12-1.22a.45.45,0,0,1-.15-.18.54.54,0,0,1-.07-.27v-4.57a.26.26,0,0,1,.07-.2s.09,0,.15,0l2.12,1.22a.39.39,0,0,1,.14.18.54.54,0,0,1,.07.27.22.22,0,0,1-.07.19A.11.11,0,0,1,446.86,182.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,189.13l-2.12-1.23a.35.35,0,0,1-.15-.18.6.6,0,0,1-.06-.27v-4.56a.28.28,0,0,1,.06-.2.12.12,0,0,1,.15,0,.45.45,0,0,1,.15.18.66.66,0,0,1,.06.27v4.08a.31.31,0,0,0,0,.13s.05.08.08.09l1.8,1a.42.42,0,0,1,.15.19.66.66,0,0,1,.06.27.25.25,0,0,1-.06.19A.12.12,0,0,1,450.33,189.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.81,186.57l-1.8-1a.06.06,0,0,0-.08,0,.13.13,0,0,0,0,.1v1.3a.35.35,0,0,0,0,.14.24.24,0,0,0,.08.09l1.37.79a.42.42,0,0,1,.15.19.59.59,0,0,1,.07.26.28.28,0,0,1-.07.2s-.09,0-.15,0l-1.37-.79a.06.06,0,0,0-.08,0,.12.12,0,0,0,0,.09v1.31a.31.31,0,0,0,0,.13.18.18,0,0,0,.08.09l1.8,1a.44.44,0,0,1,.15.19.58.58,0,0,1,.06.26.28.28,0,0,1-.06.2.11.11,0,0,1-.15,0l-2.12-1.22a.35.35,0,0,1-.15-.18.66.66,0,0,1-.06-.27v-4.57a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l2.12,1.22a.51.51,0,0,1,.15.19.58.58,0,0,1,.06.26.28.28,0,0,1-.06.2A.12.12,0,0,1,453.81,186.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,192.77l-1.49-.85a.45.45,0,0,1-.15-.18.66.66,0,0,1-.06-.27V186.9a.25.25,0,0,1,.06-.19.11.11,0,0,1,.15,0l1.49.85a1.67,1.67,0,0,1,.6.73,2.57,2.57,0,0,1,.25,1.07V192a1.07,1.07,0,0,1-.25.78A.45.45,0,0,1,456.65,192.77Zm.42-3.67a1.28,1.28,0,0,0-.12-.53.74.74,0,0,0-.3-.36l-1.17-.68a.06.06,0,0,0-.07,0,.12.12,0,0,0,0,.09v3.59a.35.35,0,0,0,0,.14.22.22,0,0,0,.07.09l1.17.67a.23.23,0,0,0,.3,0,.54.54,0,0,0,.12-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,122.32a.22.22,0,0,1-.06-.07.41.41,0,0,1,0-.11l.07-.49s0-.06,0-.07.05,0,.07,0l2,1.16a.12.12,0,0,1,.06.08.2.2,0,0,1,0,.11l-.07.48a.1.1,0,0,1,0,.08.08.08,0,0,1-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,123.81a.13.13,0,0,1-.05-.07.22.22,0,0,1,0-.11l.07-.49s0-.06,0-.07a.06.06,0,0,1,.08,0l2,1.16a.12.12,0,0,1,.06.08.2.2,0,0,1,0,.11l-.07.48a.08.08,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,127a.12.12,0,0,1-.06-.08.17.17,0,0,1,0-.1l.07-.49a.07.07,0,0,1,0-.07.06.06,0,0,1,.07,0l2,1.17a.13.13,0,0,1,0,.07.23.23,0,0,1,0,.11l-.07.49s0,.06,0,.07-.05,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,128.47a.12.12,0,0,1-.06-.08.17.17,0,0,1,0-.1l.07-.49a.07.07,0,0,1,0-.07.06.06,0,0,1,.07,0l2,1.17a.22.22,0,0,1,.06.07.45.45,0,0,1,0,.11l-.07.49s0,.06,0,.07-.05,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,132.64a.28.28,0,0,1-.06-.08.34.34,0,0,1,0-.1l.07-.49a.15.15,0,0,1,0-.08h.07l2,1.17a.11.11,0,0,1,.06.07.21.21,0,0,1,0,.11l-.07.49a.08.08,0,0,1,0,.07s0,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,134.13a.16.16,0,0,1-.05-.08.18.18,0,0,1,0-.1l.07-.49a.15.15,0,0,1,0-.08h.08l2,1.17a.11.11,0,0,1,.06.07.21.21,0,0,1,0,.11l-.07.49a.07.07,0,0,1,0,.07s0,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,137.29a.09.09,0,0,1-.06-.07.21.21,0,0,1,0-.11l.07-.48a.09.09,0,0,1,0-.08.06.06,0,0,1,.07,0l2,1.16a.16.16,0,0,1,0,.08.2.2,0,0,1,0,.11l-.07.48a.15.15,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,138.78a.09.09,0,0,1-.06-.07.21.21,0,0,1,0-.11l.07-.48a.09.09,0,0,1,0-.08s.05,0,.07,0l2,1.16a.28.28,0,0,1,.06.08.37.37,0,0,1,0,.11l-.07.48a.15.15,0,0,1,0,.08.08.08,0,0,1-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,143a.22.22,0,0,1-.06-.07.41.41,0,0,1,0-.11l.07-.49s0-.06,0-.07.05,0,.07,0l2,1.16a.12.12,0,0,1,.06.08.17.17,0,0,1,0,.1l-.07.49a.1.1,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,144.44a.13.13,0,0,1-.05-.07.22.22,0,0,1,0-.11l.07-.49s0-.06,0-.07a.06.06,0,0,1,.08,0l2,1.16a.12.12,0,0,1,.06.08.2.2,0,0,1,0,.11l-.07.48a.08.08,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,147.61a.12.12,0,0,1-.06-.08.17.17,0,0,1,0-.1l.07-.49a.1.1,0,0,1,0-.08.08.08,0,0,1,.07,0l2,1.17a.13.13,0,0,1,0,.07.23.23,0,0,1,0,.11l-.07.49s0,.06,0,.07-.05,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,149.1a.12.12,0,0,1-.06-.08.17.17,0,0,1,0-.1l.07-.49a.1.1,0,0,1,0-.08h.07l2,1.17a.22.22,0,0,1,.06.07.45.45,0,0,1,0,.11l-.07.49s0,.06,0,.07-.05,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,153.27a.28.28,0,0,1-.06-.08.34.34,0,0,1,0-.1l.07-.49a.15.15,0,0,1,0-.08.08.08,0,0,1,.07,0l2,1.17a.11.11,0,0,1,.06.07.22.22,0,0,1,0,.11l-.07.49a.08.08,0,0,1,0,.07s0,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,154.76a.16.16,0,0,1-.05-.08.18.18,0,0,1,0-.1l.07-.49a.15.15,0,0,1,0-.08h.08l2,1.17a.11.11,0,0,1,.06.07.22.22,0,0,1,0,.11l-.07.49a.07.07,0,0,1,0,.07s0,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,157.92a.09.09,0,0,1-.06-.07.21.21,0,0,1,0-.11l.07-.48a.09.09,0,0,1,0-.08.08.08,0,0,1,.07,0l2,1.16a.16.16,0,0,1,0,.08.2.2,0,0,1,0,.11l-.07.48a.15.15,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,159.41a.09.09,0,0,1-.06-.07.21.21,0,0,1,0-.11l.07-.48a.09.09,0,0,1,0-.08h.07l2,1.16a.28.28,0,0,1,.06.08.37.37,0,0,1,0,.11l-.07.48a.15.15,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,163.58a.22.22,0,0,1-.06-.07.41.41,0,0,1,0-.11l.07-.49s0-.06,0-.07.05,0,.07,0l2,1.16a.12.12,0,0,1,.06.08.17.17,0,0,1,0,.1l-.07.49a.1.1,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,165.07a.13.13,0,0,1-.05-.07.22.22,0,0,1,0-.11l.07-.49s0-.06,0-.07a.06.06,0,0,1,.08,0l2,1.16a.12.12,0,0,1,.06.08.2.2,0,0,1,0,.11l-.07.48a.08.08,0,0,1,0,.08h-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.16,168.24a.12.12,0,0,1-.06-.08.17.17,0,0,1,0-.1l.07-.49a.1.1,0,0,1,0-.08.08.08,0,0,1,.07,0l2,1.17a.13.13,0,0,1,0,.07.23.23,0,0,1,0,.11l-.07.49s0,.06,0,.07-.05,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.74,169.73a.12.12,0,0,1-.06-.08.17.17,0,0,1,0-.1l.07-.49a.1.1,0,0,1,0-.08h.07l2,1.17a.22.22,0,0,1,.06.07.45.45,0,0,1,0,.11l-.07.49s0,.06,0,.07-.05,0-.07,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,86.05l26.5,15.3a5.09,5.09,0,0,1,2.38,4c0,1.42-1.06,2-2.38,1.2L370,91.21a5.12,5.12,0,0,1-2.38-3.95C367.61,85.83,368.68,85.29,370,86.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,96.38l26.5,15.3a5.09,5.09,0,0,1,2.38,3.95c0,1.43-1.06,2-2.38,1.2L370,101.54a5.12,5.12,0,0,1-2.38-4C367.61,96.16,368.68,95.62,370,96.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,106.71l26.5,15.3a5.08,5.08,0,0,1,2.38,3.95c0,1.42-1.06,2-2.38,1.2L370,111.86a5.12,5.12,0,0,1-2.38-4C367.61,106.49,368.68,106,370,106.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,117l26.5,15.3a5.09,5.09,0,0,1,2.38,3.95c0,1.43-1.06,2-2.38,1.21L370,122.19a5.12,5.12,0,0,1-2.38-4C367.61,116.81,368.68,116.27,370,117Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,127.36l26.5,15.3a5.09,5.09,0,0,1,2.38,4c0,1.42-1.06,2-2.38,1.2L370,132.52a5.12,5.12,0,0,1-2.38-4C367.61,127.14,368.68,126.6,370,127.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,137.69l26.5,15.3a5.06,5.06,0,0,1,2.38,3.95c0,1.42-1.06,2-2.38,1.2L370,142.84a5.12,5.12,0,0,1-2.38-4C367.61,137.47,368.68,136.93,370,137.69Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Suitcase--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.56,378.34l80.92,46.72a5,5,0,0,0,4.56,0l57.41-33.15a5,5,0,0,0,2.28-3.94V357.84a5,5,0,0,0-2.28-3.94l-80.92-46.72a5,5,0,0,0-4.56,0l-57.41,33.15a5,5,0,0,0-2.28,3.94V374.4A5,5,0,0,0,295.56,378.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,390.22v35.39a4.69,4.69,0,0,0,2.28-.54l57.42-33.16a5,5,0,0,0,2.28-3.94V357.84a5.07,5.07,0,0,0-1.86-3.65c.83.72.69,1.7-.41,2.34L381,389.67A4.62,4.62,0,0,1,378.75,390.22Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,390.22v35.39a4.69,4.69,0,0,0,2.28-.54l57.42-33.16a5,5,0,0,0,2.28-3.94V357.84a5.07,5.07,0,0,0-1.86-3.65c.83.72.69,1.7-.41,2.34L381,389.67A4.62,4.62,0,0,1,378.75,390.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.27,344.27V374.4a5,5,0,0,0,2.28,3.94l80.93,46.73a4.65,4.65,0,0,0,2.27.54V390.22a4.53,4.53,0,0,1-2.26-.55L295.56,343c-1.17-.68-1.25-1.75-.24-2.48A5.07,5.07,0,0,0,293.27,344.27Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.46,353.9l-80.93-46.72a5,5,0,0,0-4.55,0l-57.42,33.15c-1.26.72-1.26,1.9,0,2.63l80.93,46.72a5.06,5.06,0,0,0,4.55,0l57.42-33.15C439.72,355.8,439.72,354.62,438.46,353.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.46,353.9l-80.93-46.72a5,5,0,0,0-4.55,0l-57.42,33.15c-1.26.72-1.26,1.9,0,2.63l80.93,46.72a5.06,5.06,0,0,0,4.55,0l57.42-33.15C439.72,355.8,439.72,354.62,438.46,353.9Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.81,356.09a.41.41,0,0,0,.18,0l1.43-.83-1.43-.83a.35.35,0,0,0-.48.13.35.35,0,0,0,.13.48l.38.22-.38.23a.34.34,0,0,0-.13.47A.33.33,0,0,0,432.81,356.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.83,354l-1.8-1a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.13l1.8,1a.35.35,0,0,1-.17.66A.41.41,0,0,1,430.83,354Zm-3.6-2.08-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.35.35,0,0,1-.17.66A.41.41,0,0,1,427.23,351.87Zm-3.6-2.08-1.8-1a.35.35,0,0,1-.13-.48.36.36,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.18A.41.41,0,0,1,423.63,349.79Zm-3.6-2.08-1.8-1a.35.35,0,0,1-.13-.48.36.36,0,0,1,.48-.13l1.8,1a.35.35,0,0,1-.18.66A.34.34,0,0,1,420,347.71Zm-3.6-2.08-1.8-1a.35.35,0,0,1-.13-.48A.35.35,0,0,1,415,344l1.8,1a.35.35,0,0,1-.18.65A.34.34,0,0,1,416.43,345.63Zm-3.61-2.08-1.8-1a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.12l1.81,1a.34.34,0,0,1,.12.47.33.33,0,0,1-.3.18A.41.41,0,0,1,412.82,343.55Zm-3.6-2.08-1.8-1a.35.35,0,1,1,.35-.6l1.8,1a.34.34,0,0,1,.13.47.33.33,0,0,1-.3.18A.31.31,0,0,1,409.22,341.47Zm-106.51-1.22a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.35.35,0,0,1,302.71,340.25Zm102.91-.86-1.8-1a.35.35,0,0,1-.13-.48.35.35,0,0,1,.48-.12l1.8,1a.34.34,0,0,1,.13.47.34.34,0,0,1-.3.18A.31.31,0,0,1,405.62,339.39Zm-99.31-1.22a.35.35,0,0,1,.13-.48l1.8-1a.36.36,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.35.35,0,0,1,306.31,338.17Zm95.71-.86-1.8-1a.35.35,0,0,1-.13-.48.35.35,0,0,1,.48-.12l1.8,1a.35.35,0,0,1,.13.48.37.37,0,0,1-.31.17A.26.26,0,0,1,402,337.31Zm-92.11-1.22a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,1,1,.35.61l-1.8,1a.34.34,0,0,1-.17,0A.37.37,0,0,1,309.91,336.09Zm88.51-.86-1.8-1a.34.34,0,0,1-.13-.47.35.35,0,0,1,.48-.13l1.8,1a.36.36,0,0,1,.13.48.37.37,0,0,1-.31.17A.26.26,0,0,1,398.42,335.23ZM313.51,334a.36.36,0,0,1,.13-.48l1.8-1a.35.35,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.34.34,0,0,1-.17.05A.38.38,0,0,1,313.51,334Zm81.3-.86-1.8-1a.34.34,0,0,1-.12-.47.34.34,0,0,1,.47-.13l1.81,1a.35.35,0,0,1,.12.48.34.34,0,0,1-.3.17A.31.31,0,0,1,394.81,333.15Zm-77.69-1.22a.35.35,0,0,1,.12-.48l1.81-1a.34.34,0,0,1,.47.13.35.35,0,0,1-.12.48l-1.81,1a.34.34,0,0,1-.17.05A.35.35,0,0,1,317.12,331.93Zm74.09-.86-1.8-1a.36.36,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.31.31,0,0,1,391.21,331.07Zm-70.49-1.22a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,1,1,.35.61l-1.8,1a.41.41,0,0,1-.18,0A.35.35,0,0,1,320.72,329.85Zm66.89-.85-1.8-1a.35.35,0,0,1,.35-.61l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.39.39,0,0,1,387.61,329Zm-63.29-1.23a.35.35,0,0,1,.13-.48l1.8-1a.36.36,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.35.35,0,0,1,324.32,327.77Zm59.69-.85-1.8-1a.35.35,0,0,1,.35-.61l1.8,1a.36.36,0,0,1,.13.48.37.37,0,0,1-.31.17A.33.33,0,0,1,384,326.92Zm-56.09-1.23a.35.35,0,0,1,.13-.48l1.8-1a.36.36,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.37.37,0,0,1-.17.05A.34.34,0,0,1,327.92,325.69Zm52.49-.85-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.36.36,0,0,1,.13.48.37.37,0,0,1-.31.17A.33.33,0,0,1,380.41,324.84Zm-48.89-1.23a.36.36,0,0,1,.13-.48l1.8-1a.36.36,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.34.34,0,0,1-.17.05A.36.36,0,0,1,331.52,323.61Zm45.28-.85-1.8-1a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.13l1.81,1a.35.35,0,0,1,.12.48.34.34,0,0,1-.3.17A.39.39,0,0,1,376.8,322.76Zm-41.67-1.23a.36.36,0,0,1,.12-.48l1.81-1a.35.35,0,0,1,.35.61l-1.81,1a.34.34,0,0,1-.17,0A.33.33,0,0,1,335.13,321.53Zm38.07-.85-1.8-1a.36.36,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.39.39,0,0,1,373.2,320.68Zm-34.47-1.23a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,1,1,.35.6l-1.8,1a.41.41,0,0,1-.18.05A.33.33,0,0,1,338.73,319.45Zm30.87-.85-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.35.35,0,0,1,.13.48.35.35,0,0,1-.3.17A.39.39,0,0,1,369.6,318.6Zm-27.27-1.23a.34.34,0,0,1,.13-.47l1.8-1a.35.35,0,1,1,.35.6l-1.8,1a.41.41,0,0,1-.18.05A.33.33,0,0,1,342.33,317.37Zm23.67-.85-1.8-1a.35.35,0,0,1,.35-.61l1.8,1a.36.36,0,0,1,.13.48.38.38,0,0,1-.31.18A.34.34,0,0,1,366,316.52Zm-20.07-1.23a.34.34,0,0,1,.13-.47l1.8-1a.35.35,0,0,1,.48.12.35.35,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.34.34,0,0,1,345.93,315.29Zm16.47-.85-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.36.36,0,0,1,.13.48.38.38,0,0,1-.31.18A.34.34,0,0,1,362.4,314.44Zm-12.87-1.23a.34.34,0,0,1,.13-.47l1.8-1a.35.35,0,0,1,.48.12.35.35,0,0,1-.13.48l-1.8,1a.26.26,0,0,1-.17.05A.36.36,0,0,1,349.53,313.21Zm9.26-.85-1.8-1a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.13l1.81,1a.35.35,0,0,1,.12.48.35.35,0,0,1-.3.18A.41.41,0,0,1,358.79,312.36Zm-5.65-1.22a.35.35,0,0,1,.12-.48l1.31-.76a1.89,1.89,0,0,1,.69-.11h.06a.32.32,0,0,1,.31.36.36.36,0,0,1-.37.34,3,3,0,0,0-.37,0l-1.28.73a.26.26,0,0,1-.17.05A.34.34,0,0,1,353.14,311.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21,342.52a.33.33,0,0,0,.3-.18.35.35,0,0,0-.13-.48l-.38-.22.38-.22a.35.35,0,0,0,.13-.48.35.35,0,0,0-.48-.13l-1.43.83,1.43.83A.41.41,0,0,0,301.21,342.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.69,387.07a.32.32,0,0,1-.3-.36.37.37,0,0,1,.37-.35c.22,0,.36,0,.37,0l1.28-.74a.34.34,0,0,1,.47.13.35.35,0,0,1-.12.48l-1.31.75a1.83,1.83,0,0,1-.69.12Zm-2-.93-1.81-1a.35.35,0,0,1,.36-.6l1.8,1a.34.34,0,0,1,.12.47.33.33,0,0,1-.3.18A.34.34,0,0,1,376.68,386.14Zm5.4-1.11a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18,0A.35.35,0,0,1,382.08,385Zm-9-1-1.8-1a.35.35,0,1,1,.35-.6l1.8,1a.34.34,0,0,1,.13.47.33.33,0,0,1-.3.18A.41.41,0,0,1,373.07,384.06ZM385.68,383a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,0,1,.48.13.36.36,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.35.35,0,0,1,385.68,383Zm-16.21-1-1.8-1a.35.35,0,0,1-.13-.48.35.35,0,0,1,.48-.12l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.31.31,0,0,1,369.47,382Zm19.81-1.11a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,1,1,.35.61l-1.8,1a.41.41,0,0,1-.18.05A.36.36,0,0,1,389.28,380.87Zm-23.41-1-1.8-1a.34.34,0,0,1-.13-.47.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.36.36,0,0,1-.31.17A.28.28,0,0,1,365.87,379.9Zm27-1.11a.36.36,0,0,1,.13-.48l1.8-1a.35.35,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.34.34,0,0,1-.17.05A.38.38,0,0,1,392.88,378.79Zm-30.61-1-1.8-1a.34.34,0,0,1-.13-.47.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.37.37,0,0,1-.31.17A.26.26,0,0,1,362.27,377.82Zm34.22-1.11a.35.35,0,0,1,.12-.48l1.8-1a.35.35,0,0,1,.36.61l-1.81,1a.34.34,0,0,1-.17.05A.35.35,0,0,1,396.49,376.71Zm-37.83-1-1.8-1a.34.34,0,0,1-.12-.47.34.34,0,0,1,.47-.13l1.81,1a.35.35,0,0,1,.12.48.34.34,0,0,1-.3.17A.31.31,0,0,1,358.66,375.74Zm41.43-1.11a.35.35,0,0,1,.13-.48l1.8-1a.35.35,0,1,1,.35.61l-1.8,1a.41.41,0,0,1-.18.05A.35.35,0,0,1,400.09,374.63Zm-45-1-1.8-1a.34.34,0,0,1-.13-.47.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.31.31,0,0,1,355.06,373.66Zm48.63-1.11a.35.35,0,0,1,.13-.48l1.8-1a.36.36,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.35.35,0,0,1,403.69,372.55Zm-52.23-1-1.8-1a.36.36,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.39.39,0,0,1,351.46,371.59Zm55.83-1.12a.35.35,0,0,1,.13-.48l1.8-1a.36.36,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.34.34,0,0,1-.48-.13Zm-59.43-1-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.35.35,0,0,1,.13.48.36.36,0,0,1-.31.17A.38.38,0,0,1,347.86,369.51Zm63-1.12a.36.36,0,0,1,.13-.48l1.8-1a.35.35,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.34.34,0,0,1-.17.05A.38.38,0,0,1,410.89,368.39Zm-66.63-1-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.36.36,0,0,1,.13.48.37.37,0,0,1-.31.17A.33.33,0,0,1,344.26,367.43Zm70.24-1.12a.36.36,0,0,1,.12-.48l1.8-1a.35.35,0,0,1,.36.61l-1.81,1a.34.34,0,0,1-.17.05A.33.33,0,0,1,414.5,366.31Zm-73.84-1-1.81-1a.35.35,0,0,1-.12-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.12.48.34.34,0,0,1-.3.17A.33.33,0,0,1,340.66,365.35Zm77.44-1.12a.35.35,0,0,1,.13-.48l1.8-1a.37.37,0,0,1,.48.13.35.35,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.33.33,0,0,1,418.1,364.23Zm-81.05-1-1.8-1a.36.36,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.39.39,0,0,1,337.05,363.27Zm84.65-1.12a.34.34,0,0,1,.13-.47l1.8-1a.35.35,0,1,1,.35.6l-1.8,1a.41.41,0,0,1-.18.05A.33.33,0,0,1,421.7,362.15Zm-88.25-1-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.35.35,0,0,1,.13.48.34.34,0,0,1-.3.17A.39.39,0,0,1,333.45,361.19Zm91.85-1.12a.34.34,0,0,1,.13-.47l1.8-1a.35.35,0,0,1,.48.12.35.35,0,0,1-.13.48l-1.8,1a.41.41,0,0,1-.18.05A.34.34,0,0,1,425.3,360.07Zm-95.45-1-1.8-1a.35.35,0,0,1,.35-.61l1.8,1a.35.35,0,0,1,.13.48.37.37,0,0,1-.48.13Zm99-1.12a.34.34,0,0,1,.13-.47l1.8-1a.35.35,0,0,1,.48.12.35.35,0,0,1-.13.48l-1.8,1a.34.34,0,0,1-.17.05A.36.36,0,0,1,428.9,358Zm-102.65-1-1.8-1a.35.35,0,1,1,.35-.61l1.8,1a.36.36,0,0,1,.13.48.38.38,0,0,1-.31.18A.34.34,0,0,1,326.25,357Zm-3.6-2.08-1.81-1a.35.35,0,0,1-.12-.48.34.34,0,0,1,.47-.13l1.81,1a.35.35,0,0,1,.12.48.35.35,0,0,1-.3.18A.34.34,0,0,1,322.65,355ZM319,352.87l-1.8-1a.36.36,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1-.17.66A.41.41,0,0,1,319,352.87Zm-3.6-2.08-1.8-1a.36.36,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.35.35,0,0,1-.17.66A.41.41,0,0,1,315.44,350.79Zm-3.6-2.08-1.8-1a.35.35,0,0,1-.13-.48.36.36,0,0,1,.48-.13l1.8,1a.35.35,0,0,1,.13.48.37.37,0,0,1-.31.18A.41.41,0,0,1,311.84,348.71Zm-3.6-2.08-1.8-1a.35.35,0,0,1-.13-.48.35.35,0,0,1,.48-.13l1.8,1a.36.36,0,0,1,.13.48.38.38,0,0,1-.31.18A.34.34,0,0,1,308.24,346.63Zm-3.6-2.08-1.81-1a.35.35,0,0,1,.36-.61l1.8,1a.35.35,0,0,1,.12.48.35.35,0,0,1-.3.18A.34.34,0,0,1,304.64,344.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,370.85,380,405.93a2.43,2.43,0,0,1-2.42,0l-84.27-48.65v3.29l84.26,48.65a2.43,2.43,0,0,0,2.42,0l60.77-35.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.57,384.74a.38.38,0,0,0,0-.1,27.76,27.76,0,0,0-21.66,0s0,.06,0,.1l8.55,4.93a4.53,4.53,0,0,0,2.26.55,4.62,4.62,0,0,0,2.29-.55l8.53-4.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,340.34l7.29-4.22c5.2,3,5.19,7.94-.06,11l0,0L295.56,343C294.3,342.24,294.3,341.07,295.56,340.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.44,353.88l-7.29-4.21c-5.2,3-5.19,7.94.05,11l.05,0,7.19-4.15A1.39,1.39,0,0,0,438.44,353.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,311.76l7.94-4.58a5,5,0,0,1,4.55,0l7.83,4.52c-.22.14-.44.29-.68.43-5.27,3-13.8,3-19.06,0C345.41,312,345.23,311.89,345,311.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.57,384.74a.38.38,0,0,0,0-.1,27.76,27.76,0,0,0-21.66,0s0,.06,0,.1l8.55,4.93a4.53,4.53,0,0,0,2.26.55,4.62,4.62,0,0,0,2.29-.55l8.53-4.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.56,340.34l7.29-4.22c5.2,3,5.19,7.94-.06,11l0,0L295.56,343C294.3,342.24,294.3,341.07,295.56,340.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M438.44,353.88l-7.29-4.21c-5.2,3-5.19,7.94.05,11l.05,0,7.19-4.15A1.39,1.39,0,0,0,438.44,353.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M345,311.76l7.94-4.58a5,5,0,0,1,4.55,0l7.83,4.52c-.22.14-.44.29-.68.43-5.27,3-13.8,3-19.06,0C345.41,312,345.23,311.89,345,311.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M367.94,384.74c.79,6.59,5.17,12.4,10.81,16.34V390.22a4.53,4.53,0,0,1-2.26-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,343l7.23,4.17c0,6-4.27,7.78-9.52,4.75v-7.62a5,5,0,0,1,2.28-3.94l.51-.3h0l-.51.3A1.39,1.39,0,0,0,295.56,343Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.28,374.4v-8.5c5.25,3,9.51,10.43,9.51,16.5v.12l-7.5-4.36A5.09,5.09,0,0,1,293.28,374.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.23,420.87c0-6.05,4.27-8.49,9.52-5.46h0v10.2a4.53,4.53,0,0,1-2.26-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M367.94,384.74c.79,6.59,5.17,12.4,10.81,16.34V390.22a4.53,4.53,0,0,1-2.26-.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.56,343l7.23,4.17c0,6-4.27,7.78-9.52,4.75v-7.62a5,5,0,0,1,2.28-3.94l.51-.3h0l-.51.3A1.39,1.39,0,0,0,295.56,343Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M293.28,374.4v-8.5c5.25,3,9.51,10.43,9.51,16.5v.12l-7.5-4.36A5.09,5.09,0,0,1,293.28,374.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M369.23,420.87c0-6.05,4.27-8.49,9.52-5.46h0v10.2a4.53,4.53,0,0,1-2.26-.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,390.22v10.86c5.66-4,10-9.76,10.82-16.34L381,389.67A4.57,4.57,0,0,1,378.75,390.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,420.87,381,425.06a4.57,4.57,0,0,1-2.27.55v-10.2C384,412.38,388.26,414.82,388.28,420.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.46,379.76l.27-.15V388a5.06,5.06,0,0,1-2,3.76l-7.79,4.53h0C430.93,390.18,435.19,382.79,440.46,379.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.44,356.5l-7.23,4.17c0,6.05,4.27,8.5,9.52,5.47v-8.33a5,5,0,0,0-2.3-3.93h0A1.38,1.38,0,0,1,438.44,356.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M378.75,390.22v10.86c5.66-4,10-9.76,10.82-16.34L381,389.67A4.57,4.57,0,0,1,378.75,390.22Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M388.28,420.87,381,425.06a4.57,4.57,0,0,1-2.27.55v-10.2C384,412.38,388.26,414.82,388.28,420.87Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M440.46,379.76l.27-.15V388a5.06,5.06,0,0,1-2,3.76l-7.79,4.53h0C430.93,390.18,435.19,382.79,440.46,379.76Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M438.44,356.5l-7.23,4.17c0,6.05,4.27,8.5,9.52,5.47v-8.33a5,5,0,0,0-2.3-3.93h0A1.38,1.38,0,0,1,438.44,356.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M356.57,390.53l4.48,2.59a1.32,1.32,0,0,1,.61,1.05v8.47a1.36,1.36,0,0,1-.61,1.05l-.41.23a1.3,1.3,0,0,1-1.21,0L355,401.33a1.32,1.32,0,0,1-.61-1.05v-8.47a1.37,1.37,0,0,1,.6-1.05l.41-.23A1.32,1.32,0,0,1,356.57,390.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.57,390.53l4.48,2.59a1.32,1.32,0,0,1,.61,1.05v8.47a1.36,1.36,0,0,1-.61,1.05l-.41.23a1.3,1.3,0,0,1-1.21,0L355,401.33a1.32,1.32,0,0,1-.61-1.05v-8.47a1.37,1.37,0,0,1,.6-1.05l.41-.23A1.32,1.32,0,0,1,356.57,390.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,404a1.28,1.28,0,0,0,1.07-.06l.41-.23a1.35,1.35,0,0,0,.61-1.05v-8.47a1.35,1.35,0,0,0-.19-.62l-1.61.95a1.26,1.26,0,0,1,.18.6v8.47C360,403.91,359.84,404.07,359.57,404Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,395.11v8.46c0,.39-.28.55-.61.35L355,401.33a1.32,1.32,0,0,1-.61-1.05v-8.47c0-.38.27-.54.6-.35l4.49,2.59A1.38,1.38,0,0,1,360,395.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,395.11v8.46c0,.39-.28.55-.61.35L355,401.33a1.32,1.32,0,0,1-.61-1.05v-8.47c0-.38.27-.54.6-.35l4.49,2.59A1.38,1.38,0,0,1,360,395.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,364.2l4.48,2.59a1.35,1.35,0,0,1,.61,1v8.47a1.32,1.32,0,0,1-.61,1.05l-.41.24a1.36,1.36,0,0,1-1.21,0L309.36,375a1.32,1.32,0,0,1-.61-1.05v-8.47a1.32,1.32,0,0,1,.61-1.05l.4-.24A1.38,1.38,0,0,1,311,364.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,364.2l4.48,2.59a1.35,1.35,0,0,1,.61,1v8.47a1.32,1.32,0,0,1-.61,1.05l-.41.24a1.36,1.36,0,0,1-1.21,0L309.36,375a1.32,1.32,0,0,1-.61-1.05v-8.47a1.32,1.32,0,0,1,.61-1.05l.4-.24A1.38,1.38,0,0,1,311,364.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,377.66a1.36,1.36,0,0,0,1.07-.06l.41-.24a1.31,1.31,0,0,0,.6-1.05v-8.46a1.15,1.15,0,0,0-.17-.61l-1.62.94h0a1.21,1.21,0,0,1,.17.6v8.47C314.44,377.58,314.25,377.74,314,377.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.45,368.78v8.47c0,.39-.28.54-.61.35L309.36,375a1.32,1.32,0,0,1-.61-1.05v-8.47c0-.39.27-.54.61-.35l4.48,2.59A1.32,1.32,0,0,1,314.45,368.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.45,368.78v8.47c0,.39-.28.54-.61.35L309.36,375a1.32,1.32,0,0,1-.61-1.05v-8.47c0-.39.27-.54.61-.35l4.48,2.59A1.32,1.32,0,0,1,314.45,368.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53,394.56V398a.9.9,0,0,0,.4.7l4.85,2.8a.89.89,0,0,0,.81,0l.27-.16a.88.88,0,0,0,.4-.69v-3.43a.88.88,0,0,0-.4-.69L345,393.71a.93.93,0,0,0-.8,0l-.27.16A.89.89,0,0,0,343.53,394.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93,398.73l4.85,2.8c.23.13.41,0,.41-.23v-3.43a.86.86,0,0,0-.41-.69l-4.85-2.81c-.22-.12-.4,0-.4.24V398A.9.9,0,0,0,343.93,398.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.92,380.36v3.43a.9.9,0,0,0,.4.7l4.85,2.8a.89.89,0,0,0,.81,0l.27-.16a.89.89,0,0,0,.4-.69V383a.9.9,0,0,0-.4-.7l-4.86-2.8a.87.87,0,0,0-.8,0l-.27.16A.88.88,0,0,0,318.92,380.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.32,384.53l4.85,2.8c.22.13.4,0,.4-.23v-3.43a.9.9,0,0,0-.4-.7l-4.85-2.8c-.22-.13-.4,0-.4.23v3.43A.9.9,0,0,0,319.32,384.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,382.77l2.87,1.66-1.6.92h0l1.59-.92v1.42l-1.59.92v1.64a4,4,0,0,0,1.82,3.16l18.26,10.55a1.64,1.64,0,0,0,.48.2,2,2,0,0,0,.07-.51v-3.09l1.27-.73h0l1.58-.92,2.85,1.64v1.43l-1.59.92v2.8a1.87,1.87,0,0,1-.7,1.57c-.25.18-1.22.72-1.42.84-1.06.63-3,.35-5.23-.94l-15.43-8.92c-3.35-1.94-6.07-5.41-6.07-7.75v-4.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,382.77l2.87,1.66-1.6.92h0l1.59-.92v1.42l-1.59.92v1.64a4,4,0,0,0,1.82,3.16l18.26,10.55a1.64,1.64,0,0,0,.48.2,2,2,0,0,0,.07-.51v-3.09l1.27-.73h0l1.58-.92,2.85,1.64v1.43l-1.59.92v2.8a1.87,1.87,0,0,1-.7,1.57c-.25.18-1.22.72-1.42.84-1.06.63-3,.35-5.23-.94l-15.43-8.92c-3.35-1.94-6.07-5.41-6.07-7.75v-4.23Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,404.6c0,2.34-2.72,2.67-6.08.73l-15.43-8.92c-3.35-1.94-6.07-5.41-6.07-7.75v-4.23l2.83-1.66,2.87,1.66-2.87,1.65v3.07a4,4,0,0,0,1.82,3.16l18.26,10.55c1,.58,1.82.11,1.82-1.05v-3.09l2.86-1.65,2.85,1.64-2.86,1.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,404.6c0,2.34-2.72,2.67-6.08.73l-15.43-8.92c-3.35-1.94-6.07-5.41-6.07-7.75v-4.23l2.83-1.66,2.87,1.66-2.87,1.65v3.07a4,4,0,0,0,1.82,3.16l18.26,10.55c1,.58,1.82.11,1.82-1.05v-3.09l2.86-1.65,2.85,1.64-2.86,1.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.34 382.77 323.2 384.43 320.33 386.09 317.51 384.43 320.34 382.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.34 382.77 323.2 384.43 320.33 386.09 317.51 384.43 320.34 382.77",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.1 397.07 347.95 398.71 345.09 400.37 342.24 398.72 345.1 397.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.1 397.07 347.95 398.71 345.09 400.37 342.24 398.72 345.1 397.07",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bolt--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "412.27 205.4 403.94 211.57 405.35 214.58 399.68 216.03 401.2 218.53 394.85 221.53 406.07 220.53 404.29 217.8 411.76 217.06 409.66 212.95 416.45 211.9 412.27 205.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.27 205.4 403.94 211.57 405.35 214.58 399.68 216.03 401.2 218.53 394.85 221.53 406.07 220.53 404.29 217.8 411.76 217.06 409.66 212.95 416.45 211.9 412.27 205.4",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392 211.18 394.86 213.32 392.39 219.89 398.75 212.53 396.57 210.65 401.43 204.92 396.1 202.47 392 211.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392 211.18 394.86 213.32 392.39 219.89 398.75 212.53 396.57 210.65 401.43 204.92 396.1 202.47 392 211.18",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.12 222.19 406.42 225.34 396.29 224.3 407.5 229.46 409.15 226.64 415.95 229.53 416.7 223.42 408.12 222.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.12 222.19 406.42 225.34 396.29 224.3 407.5 229.46 409.15 226.64 415.95 229.53 416.7 223.42 408.12 222.19",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.74,412.66a4,4,0,0,0,1.45,2.42c1.72,1.49,4.11,1.93,6.38,2.09a21.61,21.61,0,0,0,6.47-.4,12.16,12.16,0,0,0,5.69-3,27.22,27.22,0,0,0,3.11-4.11,8.83,8.83,0,0,1,4.16-3.84c.59-.36,1.17-.76,1.76-1.11a14.34,14.34,0,0,0,4.25-3c1.91-2.38,1.5-5.52,1.53-8.35,0-.69,0-1.39,0-2.08l.18-1.08c.46-6.58,5.75-22.56,6.75-25.86l-19.28-2.22c-.71,10.16-1.7,19.88-2.3,24.38a30.49,30.49,0,0,1-1.71,6.34,19.92,19.92,0,0,1-4,6.84,48.7,48.7,0,0,1-4.6,4.37,15.5,15.5,0,0,1-2.51,1.6,53.07,53.07,0,0,0-5.18,2.87A4.63,4.63,0,0,0,272.74,412.66Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.17,403.16a6,6,0,0,1-.32,1.94c-.5,1-4.52,3-6.05,3.74a9.1,9.1,0,0,0-4.72,4.74c-1.62,3.23-4.69,5.51-8.17,7a24.81,24.81,0,0,1-14.71,1.1c-6.1-1.27-6.49-4.9-6.49-4.9s-.23-3.41,1.31-3.91S308.17,403.16,308.17,403.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.78,389.85c.68.06.88.43.76,1.13a34.79,34.79,0,0,0-.22,4.91c.11,1.79.69,5.13-.15,7.27-3.34,3.2-8.46,3.89-11,7.24s-5,7.55-13,8.92S270,418,268.6,415.64s0-4.44,5.22-7.08c5.54-2.79,13-11.38,13-11.38a37.87,37.87,0,0,0,2.82-3.84,31.37,31.37,0,0,0,1.88-4.31,3.51,3.51,0,0,1,1.28-1.71,3.58,3.58,0,0,1,2.13-.21,15.72,15.72,0,0,1,3.42.61,5.21,5.21,0,0,1,2.77,2,24.79,24.79,0,0,0,1.21,2.21,3,3,0,0,0,3,1,3.53,3.53,0,0,0,2.24-1.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,417.55a10.19,10.19,0,0,0-5.7-8.88c-6-3.27-9.7-1.38-11.59-.09-2.25,1.52-5.5,4.75-3.65,7.21,2,2.66,5.27,4,11.45,4.23S289.37,417.55,289.37,417.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.19,399a.71.71,0,0,1-.54-.3c-.66-1-5-4.68-9.25-3.62-.21-.5.16-1,1.05-1.49,4.49-.28,8.57,3.21,9.37,4.39a.65.65,0,0,1-.2.92A.74.74,0,0,1,298.19,399Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.87,398.22a2.06,2.06,0,0,1,1.25-1.44c4.25,0,8,3.28,8.81,4.41a.66.66,0,0,1-.21.92.71.71,0,0,1-.42.1.66.66,0,0,1-.54-.3C294.11,401,290,397.45,285.87,398.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,404.93a3.87,3.87,0,0,1,2-1.73c4.4-.17,8.4,3.23,9.18,4.4a.65.65,0,0,1-.2.92.71.71,0,0,1-.42.1.72.72,0,0,1-.55-.3C288.27,407.29,283.51,403.22,279,404.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4,405.42a.7.7,0,0,1-.54-.3c-.65-1-4.87-4.6-9.11-3.65a2.39,2.39,0,0,1,1.47-1.49c4.25,0,8,3.28,8.81,4.41a.64.64,0,0,1-.21.92A.7.7,0,0,1,292.4,405.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.94,339.12c-6.38-4.45-46.75-16.92-50-16.18-14-4.95-25-9.34-37.65-10.81-18.63-2.17-21.08,11.12-22.07,24.06h0c-.1,1-.18,2-.24,3.1C294,357.71,293.09,376,293.09,376c2.24,3.16,13.53,6.93,17.54,2.24,0,0,2.87-7.87,5.69-17.73.86-3,1.87-5.73,2.76-8.44,11.24,6.83,23.69,12.49,34.62,10.88,11.26-1.67,37.63,4.38,49-13.72A35.51,35.51,0,0,0,404.94,339.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.49,340.76c-4.66,13.58-13.74,20.67-23.79,22.16-10.93,1.61-23.38-4.05-34.62-10.88,1.92-5.8,3.28-11.44,1.29-19.19a139.33,139.33,0,0,1,13.44,15.3c5.57,7.63,13.58,12,24.95,8.22A33.44,33.44,0,0,0,377.49,340.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.19,343.7c-10.4,2.36-27.66-9.31-34.61-14.44-4-3-7.45-4.12-9.37-3.11-.77.4-1.66,1.34-1.59,3.56,0,.72.07,1.51.12,2.35.28,4.87.66,11.54-2.21,19.8C311,359,307.65,373.24,306,380.33a10.22,10.22,0,0,0,1.15-.19c1.66-7.21,5-20.95,7.38-27.93,2.94-8.46,2.55-15.25,2.27-20.21-.05-.83-.1-1.61-.12-2.33,0-1.33.3-2.2,1-2.58,1.49-.78,4.65.38,8.24,3,7.06,5.21,24.65,17.09,35.48,14.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.64,427.69a4,4,0,0,0,1.45,2.42c1.73,1.49,4.11,1.93,6.39,2.09a21.54,21.54,0,0,0,6.46-.4,12.11,12.11,0,0,0,5.69-3,26.57,26.57,0,0,0,3.11-4.11,13,13,0,0,1,2.65-3,14.48,14.48,0,0,1,1.52-.87c.59-.35,1.16-.75,1.76-1.1a14.42,14.42,0,0,0,4.24-3c1.91-2.38,1.51-5.52,1.53-8.35,0-.69,0-1.39,0-2.08l.18-1.08c.46-6.58,5.75-22.56,6.76-25.86l-19.28-2.22c-.72,10.16-1.71,19.88-2.31,24.38a30.47,30.47,0,0,1-1.7,6.34,19.87,19.87,0,0,1-4,6.84,48.58,48.58,0,0,1-4.59,4.37,16.42,16.42,0,0,1-2.51,1.6,53.07,53.07,0,0,0-5.18,2.87A4.66,4.66,0,0,0,298.64,427.69Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.07,418.19a5.75,5.75,0,0,1-.32,1.94c-.49,1-4.52,3-6.05,3.74a9.1,9.1,0,0,0-4.72,4.74c-1.61,3.23-4.69,5.51-8.17,7a24.77,24.77,0,0,1-14.7,1.1c-6.1-1.27-6.5-4.9-6.5-4.9s-.23-3.41,1.32-3.91S334.07,418.19,334.07,418.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.69,404.88c.68.06.87.43.75,1.13a36.43,36.43,0,0,0-.22,4.91c.12,1.79.69,5.13-.15,7.27-3.34,3.2-8.45,3.89-11,7.24s-5,7.55-13,8.92-14.1-1.35-15.52-3.68,0-4.44,5.22-7.08c5.55-2.79,13-11.38,13-11.38a38,38,0,0,0,2.83-3.84,31.86,31.86,0,0,0,1.87-4.31,3.47,3.47,0,0,1,1.29-1.71,3.58,3.58,0,0,1,2.13-.21,15.83,15.83,0,0,1,3.42.61,5.2,5.2,0,0,1,2.77,2,24.71,24.71,0,0,0,1.2,2.21,3,3,0,0,0,3,1,3.53,3.53,0,0,0,2.24-1.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.28,432.58a10.21,10.21,0,0,0-5.7-8.88c-6-3.27-9.71-1.38-11.6-.1-2.25,1.53-5.5,4.76-3.65,7.22,2,2.66,5.28,4,11.45,4.23S315.28,432.58,315.28,432.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.1,414a.7.7,0,0,1-.54-.3c-.66-1-5-4.69-9.26-3.62-.2-.5.17-1,1.06-1.49,4.48-.28,8.57,3.21,9.37,4.39a.65.65,0,0,1-.21.92A.71.71,0,0,1,324.1,414Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.77,413.25a2.11,2.11,0,0,1,1.25-1.44c4.25,0,8,3.28,8.81,4.41a.64.64,0,0,1-.21.92.73.73,0,0,1-1-.2C320,416,315.93,412.48,311.77,413.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,420a4,4,0,0,1,2-1.74c4.41-.16,8.4,3.24,9.19,4.41a.65.65,0,0,1-.21.92.71.71,0,0,1-.42.1.7.7,0,0,1-.54-.3C314.17,422.32,309.41,418.25,304.9,420Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.31,420.45a.73.73,0,0,1-.55-.31c-.65-1-4.87-4.59-9.11-3.64a2.39,2.39,0,0,1,1.47-1.49,12.69,12.69,0,0,1,8.81,4.41.65.65,0,0,1-.2.92A.72.72,0,0,1,318.31,420.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.94,339.12c-6.38-4.45-20.94-2.5-24.16-1.76-14-4.95-24.88-8.73-37.54-10.2-18.63-2.17-21.08,11.12-22.08,24.06h0c-.09,1-.17,2-.24,3.1C319.87,372.73,319,391,319,391c2.24,3.15,13.54,6.93,17.55,2.24,0,0,2.86-7.87,5.68-17.73.86-3,1.88-5.74,2.77-8.44,11.24,6.82,23.69,12.49,34.61,10.88,11.27-1.67,21.32-10.34,25.3-27.35A31.6,31.6,0,0,0,404.94,339.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.4,355.79c-4.67,13.58-13.74,20.67-23.79,22.15-10.93,1.62-23.39-4-34.62-10.87,1.91-5.8,3.27-11.44,1.28-19.19a137.24,137.24,0,0,1,13.44,15.3c5.58,7.63,13.58,12,25,8.22A33.48,33.48,0,0,0,403.4,355.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,339.29c.32,6.16-.82,16.88-12.15,19.44-10.4,2.36-27.66-9.31-34.6-14.44-4-3-7.46-4.12-9.38-3.11-.76.4-1.66,1.34-1.59,3.56,0,.72.07,1.51.12,2.35.28,4.87.67,11.53-2.2,19.8-2.49,7.17-5.88,21.38-7.52,28.47a10.42,10.42,0,0,0,1.14-.19c1.67-7.21,5-20.95,7.39-27.93,2.94-8.47,2.55-15.25,2.26-20.21,0-.84-.09-1.61-.12-2.33,0-1.33.3-2.2,1-2.58,1.49-.78,4.65.38,8.24,3,7.06,5.21,24.65,17.09,35.48,14.63,12.09-2.74,13.32-14,13-20.55Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hair--inject-5",
    d: "M348.6,226l.32-.36a11.91,11.91,0,0,1,4.42-3c.39-.14,4.53-.35,4.35-.09,2.08-2.94,6.38-4.72,9.94-5,12.17-.81,16.72,5.22,17.51,7.7a7.12,7.12,0,0,1,7.34,3.82c1.18,2.1,1.59,4.19,3.53,5.62s4.32,2.7,5,5-.61,4.67-.28,7,2.68,3,4,4.6a7.47,7.47,0,0,1,1.5,6.25c-.36,1.52-1.19,2.91-1.37,4.46-.32,2.83,1.57,5.36,3.2,7.69s3.11,5.29,2,7.9c-.86,1.94-2.93,3-4.89,3.85s-4.07,1.68-5.26,3.45c-1.74,2.61-1,6.65-3.51,8.57-1.95,1.5-4.75.8-7.05-.06a14.19,14.19,0,0,0-4.69-1.17c-1.65,0-2.72.95-4.23,1.43a10.62,10.62,0,0,1-8.45-.43c-2.41-1.21-3.13-4.2-5.26-5.83-1.79-1.37-4.14-1.7-6.38-1.91s-4.58-.35-6.53-1.46-3.41-3.5-2.64-5.61c.36-1,1.13-1.78,1.27-2.8.31-2.14-2.12-3.55-4.18-4.24s-4.54-1.8-4.58-4c-.06-2.83,4.33-4.56,3.68-7.32-.42-1.78-2.61-2.36-3.95-3.6a4.48,4.48,0,0,1,2.51-7.76,4.19,4.19,0,0,1-2.47-7.39,1.83,1.83,0,0,0,1.11,2.76,2.7,2.7,0,0,0,2.86-1.63,5.28,5.28,0,0,0,.1-3.49c-.31-1.15-.8-2.24-1.11-3.39A10.86,10.86,0,0,1,348.6,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,269.21c-9.69.34-11.66,3.14-17.17,10-8.48,10.57-15,18.75-15,18.75s-.19,7.14-.51,16.79c4,2.24,11.6.82,22.84-6.81,11.41-7.75,16.95-11.81,16.95-11.81Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-5",
    d: "M399.84,274.53s-9.11-4.31-17.49-5.32a83,83,0,0,0-21.67,0,72.83,72.83,0,0,0-12,15.56c-4.66,8-4.18,13.17-3.82,17.49.52,6.47,6.19,10,6.19,10a84.15,84.15,0,0,0,.59,10.79c4.17,8,12.8,9.07,29.16,14.35C389.51,343,396,350.6,404.9,350.6c1.77-12.8,2.53-33.34,2.19-39.92C406.55,300,403.58,282.73,399.84,274.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.66,312.86c6.09,5.37,20.28,4.71,24.93-3.78-.83,5.37-5.87,8.9-11.1,9.53C370.74,319.42,365.58,317,363.66,312.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.29,248.08c-.18-1.91-.57-6.78-3.36-5.39-.33.16-.09,1.36,0,3.47-.65-.58-1.73-.55-1.91,0a12.18,12.18,0,0,0-.25,2.46c0,2.15-.89,6.7-.74,9.3.73,3.47,2.38,10.77,1.58,12.06-2.25,3.61-4.55,6.13-8.74,11.06s-7.46,8-11.71,13.67c-3.47,4.62-3.78,8.33-2.74,14.63,1,6,4.43,6.26,7.88,5.56,7.53-1.5,10.18-4.45,12.93-11.4,4.56-11.5,8-19.11,9.95-23,2.38-4.71,4.19-8.05,4.76-8.94,1.66-2.58.8-5.07-1.92-7C353.46,261.16,352.45,253.42,352.29,248.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.6,267.88a6.4,6.4,0,0,0-2.61-3.36c-4.53-3.36-5.54-11.1-5.7-16.44-.14-1.55-.43-5-2-5.57-.57,3.65-.21,11.37.78,16,1,4.91,3.73,8,5.73,8.85A11.27,11.27,0,0,0,360.6,267.88Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9,246.16c1.1.5,1.28,5.73,1.28,5.73a39,39,0,0,0,0-4.53c-.41-2.09-1.34-2.38-1.34-2.38Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.4,233.69c-1.51,2.89-1.89,12.18-1.46,16.7.78,8.23,3.4,12.84,6.17,14.76,2.05,1.43,5.92,1.52,9.68.81l1.73,5.41s-8.76,8.1,0,10.45c3.35.89,7.53-.67,11.43-3.66,4.94-3.79,5.82-7.93,5.82-7.93l-3.92-17.55s1.83,2.2,5.29-.05c4.4-2.86,4.43-9.45.66-11-3.08-1.31-4.9.62-5.38,2.07-.35,1-.82,3.73-1.72,4.81-.49.57-1.6,1.18-2.24.3a3.27,3.27,0,0,1-.36-1.87c-.21-4.2-3.35-4.41-3.24-8.28.11-3.54-.65-6.65-4.84-7.81-3.26-.9-7.09,3.57-9.27,2.45S355.51,227.73,352.4,233.69Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5,241.86l4.19,1.72a2.37,2.37,0,0,0-1.28-3A2.2,2.2,0,0,0,367.5,241.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.16,240.72l-4.1-2a2.19,2.19,0,0,0,1,3A2.39,2.39,0,0,0,358.16,240.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.5 242.48 362.1 253.08 356.33 250.82 363.5 242.48",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,245.31a1.62,1.62,0,1,1-1.58-1.66A1.62,1.62,0,0,1,357.22,245.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,246.43a1.62,1.62,0,1,1-1.58-1.66A1.62,1.62,0,0,1,370,246.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.55,257.1a2.07,2.07,0,0,0-1.06-.38l-.45,0a3,3,0,0,0-2.42,1c-.05.06-.12.18,0,.26s.2,0,.29.06a3.48,3.48,0,0,0,.64-.07,2.69,2.69,0,0,1,.57,0,12.62,12.62,0,0,1,1.37.1,1.74,1.74,0,0,0,1.19-.12C366.9,257.72,366.78,257.25,366.55,257.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,266c4.1-1.17,5.62-1.61,8.32-3.31a11.51,11.51,0,0,0,4.85-8.07c.14,2.47-.37,7.53-3.8,10-3.22,2.27-8.62,3.78-8.62,3.78Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.56,322.86c-.51-6.33-1.35-18.79-2.95-29.3s-2.11-16.28-12.67-19.44c-11.41,6.59-7.88,23.72-7.88,23.72l3.46,22.56s-18.18,2.36-26.71,1.5c-3.15-.32-10.27-7.14-12.34-7.76-3.59-1.07-7.11-.8-14.35-.74-6,.05-7.4,2.24-7.4,2.24s4.7,1.46,6.35,2,5.37,3.78,6.91,7.68,15.53,8.48,22.18,9.71h0A129.77,129.77,0,0,0,397,339.23c4.32.22,13,.61,15-1.65C414.69,334.67,415,328.61,414.56,322.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.52,320.4c7.17-.71,9.56-.45,12,.13-2.62-2.62-12.29-1.8-12.29-1.8Z",
    style: {
      fill: "#f0997a"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leg--inject-5"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "125.06 381.44 130.79 382.47 131.15 378.39 126.67 379.36 125.06 381.44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,370.11s-2,2.94-2.62,3.88,1.7,6.35,2.42,7.45l1.61-2.09a20.56,20.56,0,0,1,.18,5c0,1.84-.57,5,.54,8.08,1.65,4.54,5.87,8.86,10.87,12.09s8.68,3.72,10.79,3.48,3.35-1.26,3.76-2.78S125.26,370.11,125.26,370.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.13,367.87l1.23-1.71c1,.54-.57,3.14-.53,6.21a53.22,53.22,0,0,0,1.7,13.48c2.37,7.82,5.23,13.54,6.27,17,1.4,4.69-6.73,6-14.8.53-4-2.7-10.11-9.16-10.72-12.84s.4-8.25-.2-11-3.08-6.67-2.82-9.45c.14-1.52,2.09-4.11,3.83-6.26,1.59-2,3.63-5.24,4.69-4.25l-.58,1.17c-.06,1.24.16,3.48,3.16,6C137.86,368.08,142.74,371.19,145.13,367.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,368.49c1.67.81,3.7,1.31,5.23.27l.05,0a4.7,4.7,0,0,0-.94,4c.45,2.64,2.53,20.56,2.53,20.56S143.14,378,142.6,375c-.8-4.31-1.39-5.11-3.62-6.55Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13,373a.6.6,0,0,1-.84.11.59.59,0,0,1-.11-.83.6.6,0,0,1,.83-.12A.61.61,0,0,1,139.13,373Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,377.18a.59.59,0,1,1-.12-.83A.6.6,0,0,1,140,377.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.81,381.37a.59.59,0,1,1-.12-.83A.6.6,0,0,1,140.81,381.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.64,385.56a.59.59,0,1,1-.94-.71.58.58,0,0,1,.83-.12A.59.59,0,0,1,141.64,385.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48,389.75a.59.59,0,1,1-.94-.71.58.58,0,0,1,.83-.12A.59.59,0,0,1,142.48,389.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.51,372.83a.23.23,0,0,1-.09-.14.24.24,0,0,1,.18-.29,9.78,9.78,0,0,1,7.13,1.16h0a.25.25,0,0,1,.06.33.24.24,0,0,1-.33.07,9.41,9.41,0,0,0-6.75-1.09A.24.24,0,0,1,138.51,372.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,377a.24.24,0,0,1,.08-.42,9.76,9.76,0,0,1,7.13,1.15h0a.23.23,0,0,1,.06.33.24.24,0,0,1-.33.07,9.44,9.44,0,0,0-6.74-1.09A.23.23,0,0,1,139.36,377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,381.21a.23.23,0,0,1-.09-.14.24.24,0,0,1,.18-.29,9.76,9.76,0,0,1,7.12,1.16h0a.25.25,0,0,1,.06.33.23.23,0,0,1-.33.06,9.5,9.5,0,0,0-6.75-1.08A.28.28,0,0,1,140.19,381.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,385.4a.23.23,0,0,1-.09-.14.24.24,0,0,1,.17-.29,9.78,9.78,0,0,1,7.13,1.16h0a.25.25,0,0,1,.06.33.24.24,0,0,1-.34.06c-2.92-2-6.71-1.09-6.74-1.08A.28.28,0,0,1,141,385.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,389.59a.23.23,0,0,1-.09-.14.24.24,0,0,1,.17-.29,9.78,9.78,0,0,1,7.13,1.16h0a.25.25,0,0,1,.06.33.24.24,0,0,1-.34.06c-2.92-2-6.71-1.09-6.74-1.08A.28.28,0,0,1,141.87,389.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,310c-10.85-12.65-33.55-27.82-33.55-27.82l-9.69-2s-8.62,24.1-4,28.37l25.07,19c-3.09,4.1-7.21,8.26-9.83,16.18-3.55,10.75-6.78,18.47-6.78,18.47-1.35,4.33,7.06,13.75,16.39,11.73,0,0,17.35-33.49,21.49-40.74C170.63,327.55,174.45,317.1,168.36,310Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leg--inject-5"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.21 413.3 145.1 411.44 143.43 407.43 139.7 410.54 139.21 413.3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,402.56s-.43,3.75-.55,4.93,4.73,5.13,6,5.81l.49-2.76a21.55,21.55,0,0,1,2.64,4.65c.88,1.74,1.95,5,4.5,7.32,3.79,3.44,9.88,5.42,16.17,6s10-.79,11.85-2.06,2.52-2.83,2.16-4.46S133.81,402.56,133.81,402.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.37,390.65l.31-2.2c1.16,0,1,3.22,2.56,6.08a56.51,56.51,0,0,0,8.25,11.83c6.08,6.17,11.59,10.13,14.3,12.91,3.62,3.71-3.38,8.93-13.64,7.79-5.09-.56-14-3.62-16.41-6.77s-3.69-7.94-5.62-10.25-6.18-4.75-7.31-7.48c-.62-1.5-.07-4.89.51-7.77.53-2.64.83-6.71,2.31-6.3l0,1.38c.55,1.19,1.87,3.19,6,4.11C144.64,394.44,150.77,395,151.37,390.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.91,394.27c2-.07,4.12-.6,5-2.33,0,0,0,0,0-.06a5,5,0,0,0,1.1,4.27c1.72,2.25,12.52,18.06,12.52,18.06s-10.14-13.11-12.08-15.58c-2.88-3.65-3.83-4.11-6.63-4.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.26,398.43a.63.63,0,1,1-.52-.73A.64.64,0,0,1,148.26,398.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,402a.64.64,0,0,1-.72.52.63.63,0,0,1-.52-.73.64.64,0,0,1,.72-.52A.63.63,0,0,1,151.11,402Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,405.47a.63.63,0,1,1-.52-.73A.65.65,0,0,1,154,405.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.82,409a.64.64,0,0,1-.72.52.63.63,0,1,1,.72-.52Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,412.51a.62.62,0,0,1-.72.52.63.63,0,0,1-.52-.73.63.63,0,0,1,.73-.51A.62.62,0,0,1,159.67,412.51Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,398.58a.24.24,0,0,1-.15-.09.25.25,0,0,1,0-.36c.13-.11,3.32-2.87,7.26-2.42h0a.26.26,0,0,1,.22.28.26.26,0,0,1-.28.22c-3.73-.42-6.85,2.28-6.88,2.31A.25.25,0,0,1,147.6,398.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.46,402.09a.26.26,0,0,1-.16-.09.26.26,0,0,1,0-.36c.14-.11,3.32-2.87,7.27-2.43h0a.25.25,0,0,1,.22.28.26.26,0,0,1-.28.23c-3.72-.42-6.84,2.28-6.87,2.3A.31.31,0,0,1,150.46,402.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31,405.62a.29.29,0,0,1-.16-.09.24.24,0,0,1,0-.35,10.29,10.29,0,0,1,7.26-2.43h0a.25.25,0,1,1-.07.5c-3.71-.42-6.84,2.28-6.87,2.31A.25.25,0,0,1,153.31,405.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,409.14a.27.27,0,0,1-.15-.09.25.25,0,0,1,0-.35,10.32,10.32,0,0,1,7.27-2.43h0a.25.25,0,0,1,.22.28.26.26,0,0,1-.28.22c-3.72-.42-6.84,2.28-6.87,2.31A.27.27,0,0,1,156.16,409.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,412.66a.29.29,0,0,1-.16-.09.24.24,0,0,1,0-.35,10.29,10.29,0,0,1,7.26-2.43h0a.25.25,0,0,1,.21.28.24.24,0,0,1-.28.22c-3.72-.42-6.84,2.28-6.87,2.31A.25.25,0,0,1,159,412.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,322.34c-8.39-7.57-23.85-19.31-23.85-19.31a52.48,52.48,0,0,0,2.13-9.1c.93-7.13-1.66-12.16-2.18-13.78l-49.37,9.32c1.55,7.77,2.46,11.68,3.63,15.56,3.92,12.92,7.23,16.1,22.28,23.86,14.13,7.29,17.91,9.95,26.33,14.58-1.49,7.57-.53,14,1,20.87,1.5,6.56,5.25,30.12,5.25,30.12s8.7,6,20.28-.23c0,0,1.07-40.34,1.45-48.68C156.53,333.89,156.78,329.32,149,322.34Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,304.42s14,10.35,22.35,17.92c7.76,7,7.51,11.55,7,23.21-.38,8.34-.35,9.71-.35,9.71s2.81-16,2.37-22.53-1.38-8-8.38-14.6a207,207,0,0,0-17.87-14.27s4.51-5.5,4.18-11.16C134.72,299.48,126.67,304.42,126.67,304.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.33,216.1c4-.58,11.47.25,15.1,4.06s6.14,8.82,11,20.05c4,9.17,8.21,20.9,5.74,24.56s-12.33,4-12.33,4Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,215.69c6.44-.36,12.66-.55,17.53,5.32,5.18,6.26,15.23,29.79,15.44,35.33,0,0-7.45-7.07-17.37-5.84C118.25,231.48,110.19,215.69,110.19,215.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,243.24c7.44-1.81,14.75-2.29,17.38-.11s1.6,4.38,2.55,5.26,3.29,10.21,1.52,10l-.42-2s-7.3-7-17.37-5.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,248.09a5.08,5.08,0,0,1-.36-1.5c-8.48-4.4-12.91-2.63-12.91-2.63C133.32,243.62,138.15,245.57,141.84,248.09Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.16,249.24c2.08-1,6.25-2.11,12.85-.49-3.67-1.71-9.69-2.56-13.58-.95Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,216.3c-4.56.72-17.47,6.76-21,7.76-3,1.65-6.19,6.13-5.74,10.59,1.55,15.33,2.62,18.76,7.24,39C74.05,289.17,78,302.05,78,302.05c23.94,1.15,54.19-12.58,56.86-19.86,0,0-7.46-24.3-12.25-44.53-4.27-18.08-7.54-22-12.47-22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.22,186.92c2.25-5,.2-11.66-2.37-14.81-3.72-4.56-9.57-6.58-18.43-6.15-6.74.34-13.39,3-14.74,9.94-6.63,2-6.24,10-5,13.92,2.63,8,7.77,14.34,9.32,19.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,205.63c-1.11,3.83-3.37,6.62-6.93,7.13a35.23,35.23,0,0,1-6.06,0l.38,6.48c.74,1.54.08,3.6-.79,5.45-2.21-3.75-14.74.38-18.44-5.28l.32-17.62s-1.84,2.54-5.4.16c-2.43-1.64-4.92-5.75-3.08-9.54s6.13-2.19,7.21-1,2.33,3.31,3.24,3a3.3,3.3,0,0,0,2.24-2.22,20,20,0,0,0,1.25-7.25,6.49,6.49,0,0,0,2.81-2.11c.85-1.34.86-3.16,3.1-5.37,3.4-3.36,16.12-3.52,19.06,1.3,1.8,3.25,1.77,10.77,2,15.11A35.63,35.63,0,0,1,118,205.63Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,212.72c-3.92-.27-11.35-2.22-13.43-4.44s-2.91-6.71-2.91-6.71.24,5.67,1.83,8.19,5.7,3.66,8.18,4.32,6.49,1.35,6.49,1.35Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.26,184.52l4.14,1a2.24,2.24,0,0,1-2.67,1.57A2.08,2.08,0,0,1,98.26,184.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,186.55l-4.09-1.34a2.06,2.06,0,0,1,2.64-1.42A2.26,2.26,0,0,1,116,186.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.78,190.63a1.74,1.74,0,1,0,1.74-1.75A1.76,1.76,0,0,0,99.78,190.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,189.63a1.74,1.74,0,1,0,1.74-1.75A1.59,1.59,0,0,0,112,189.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.66 186.33 107.73 197.45 113.65 195.49 106.66 186.33",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,191.39c.5,7.58,3,8.57,5.69,9,3.58.52,6.89-1.2,11.83-1.61,3.87-.32,5.29,1.19,7.51,2.06,1.64.64,2.94.6,3.33-1.24a61.8,61.8,0,0,0,.33-10.25,72,72,0,0,1,.35,13.78c-.46,3.58-1.82,6.54-3.76,8.24-2.69,2.36-8,2.48-15.2,1S89.87,208.14,89,205.64c-2.94-8.14-2.4-12.31-3.37-13.84S90,191.39,90,191.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,203.67l-3.21-.79a1.63,1.63,0,0,1,2-1.27A1.74,1.74,0,0,1,107,203.67Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,226.66a6.13,6.13,0,0,0,.6-3.32l-2.3-1.67,0,2.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,226.66a6.13,6.13,0,0,0,.6-3.32l-2.3-1.67,0,2.89Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.31 224.88 97.37 221.47 92.9 225 101.92 228.77 103.31 224.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.31 224.88 97.37 221.47 92.9 225 101.92 228.77 103.31 224.88",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.84,231.13c.62,4.1,3,24.41,3,38.16,0,3.37,4,9.57,5.13,9.43s6.74-8.24,7-12c-.44-9-9.1-32.15-12.3-36.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.88,231q-.09-.21-.18-.39l-2.86.5.17,1.2A5,5,0,0,0,107.88,231Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,224.88a12.7,12.7,0,0,1,2.72-.32,6.48,6.48,0,0,1,1.74,2.1,5.94,5.94,0,0,1-.07,4,3.45,3.45,0,0,1-2.86.5s-2.35-.78-2.92-2.36A5.47,5.47,0,0,1,103.31,224.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.65,266.22c-2-13.8-3.6-36.38-11.29-41.44-5.25,1.32-10.59,5.41-9.87,15.52.26,3.75.62,5.34,2.31,15,1.32,7.47,2.61,15.83,3.81,24.67.86,6.37,3.39,7.48,10.23,7.59,5.7.09,23.41-4.08,32.89-7.38,11.55-4,22.76-10.16,21.9-14.12-.51-2.24-3.65-5.72-5.68-5.72C118.87,260.31,81.65,266.22,81.65,266.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,260.31c-6.43,0-37.66,4.87-43.39,5.77h0c2.9-.29,8.4.5,14.48,2.29a86,86,0,0,0,23.47,2.93c2.63,0,5.33-.13,7.81-.27,2.33-1.82,3.62-3.56,3.31-5C131.12,263.79,128,260.31,126,260.31Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.72,246.31c-1.26-8.07-.81-12.4,1.05-16.12,1.46-2.9,5.9-5.41,12.19-7.16,6.4,8.67,7.42,22.27,7.42,22.27l2.33,18.11c-4.95,2.33-10.43,10.07-14.93,18.46,0,0-2.14-.83-2.55-4.64C64.23,277.23,60.53,257.81,58.72,246.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,265.65c7.8-.1,36.87,5.59,50.23,2.06.35-1.16,1.77-2.75.89-8.16-.92-5.63-8.59-9.33-12.14-9.13-30.33,3.66-41,12.88-42.57,14.15a8.3,8.3,0,0,0-1.25,1.51S85.17,265.77,87.4,265.65Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.56,266.08c-1.94.36-6.54,3.67-10,8-3.67,4.49-5,8.2-5.19,9l.66,1.4a2.37,2.37,0,0,1-2.56-.95c-.79-1.39-.35-2.33-.56-3.1-.42-1.57-1.72-1.27-1.54-4.52.09-1.54-.72-3-.86-4.09s.75-4.88,7.16-9.2,10.7-4,11.52-3.61a1.12,1.12,0,0,1,.64,1.65c-.43.9.8,1.16.32,2.54C81.8,264.08,83.18,264.94,82.56,266.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.39,264.42a1.73,1.73,0,0,1-.3-1.12A18.14,18.14,0,0,0,75.48,267c-5.15,4.26-5.54,7.64-5.54,7.64C72.31,269.67,79.17,265.38,82.39,264.42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,273.15a12.72,12.72,0,0,1,.45,1.72,22.74,22.74,0,0,1,11.63-10.4S68.57,265.52,62.8,273.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.31,210.23l-.07,3.57c.72,3.7,4.1,5,9.81,6.67s7.71,1.2,8.53,4.18c0,0-2.24-1.77-4.53-.78-2.92,1.25-4.12,7.74-5.34,7.7s-7.29-1.89-10.49-5.26a31.23,31.23,0,0,1-4.53-6.46C83.81,217.27,84.39,210,86.31,210.23Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.58,224.65c4.07-4,5.84,2.23,6.34,1.48s-1.73-11.44-5.9-13l.35,6.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bolt--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "57.96 155.98 66.29 162.16 64.89 165.17 70.56 166.62 69.03 169.12 75.38 172.12 64.16 171.12 65.95 168.39 58.47 167.65 60.57 163.54 53.79 162.49 57.96 155.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.96 155.98 66.29 162.16 64.89 165.17 70.56 166.62 69.03 169.12 75.38 172.12 64.16 171.12 65.95 168.39 58.47 167.65 60.57 163.54 53.79 162.49 57.96 155.98",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.23 161.77 75.37 163.91 77.85 170.48 71.48 163.12 73.66 161.24 68.8 155.51 74.13 153.06 78.23 161.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.23 161.77 75.37 163.91 77.85 170.48 71.48 163.12 73.66 161.24 68.8 155.51 74.13 153.06 78.23 161.77",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.11 172.78 63.81 175.93 73.94 174.89 62.73 180.05 61.08 177.23 54.28 180.12 53.53 174.01 62.11 172.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.11 172.78 63.81 175.93 73.94 174.89 62.73 180.05 61.08 177.23 54.28 180.12 53.53 174.01 62.11 172.78",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--suitcase--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Luggage--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.51 297.56 84.55 298.74 84.55 321.9 82.51 320.72 82.51 297.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.6 297.56 84.55 298.74 84.55 321.9 86.6 320.72 86.6 297.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.07 284.03 57.03 282.85 57.03 306.01 59.07 307.19 59.07 284.03",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.07 284.03 61.12 282.85 61.12 306.01 59.07 307.19 59.07 284.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,274.81a1.43,1.43,0,0,1,1.57.08l28.84,16.65A5.55,5.55,0,0,1,89.76,296v3.45l-2.24,1.29L54.05,281.38v-3.45a2.07,2.07,0,0,1,.78-1.86C55.23,275.83,56.67,275.05,57,274.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21,292.83,56.37,276.18c-1.28-.74-2.32,0-2.32,1.75v3.45L87.52,300.7v-3.45A5.52,5.52,0,0,0,85.21,292.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,436.18a3.14,3.14,0,0,1,3.13-.33c.82.46,3.66,2.13,4.47,2.58a3.13,3.13,0,0,1,1.33,2.9,9.88,9.88,0,0,1-4.47,7.74,3.16,3.16,0,0,1-3.13.33c-.82-.46-3.71-2.13-4.52-2.61a3.18,3.18,0,0,1-1.28-2.88A9.85,9.85,0,0,1,64,436.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,449.07c-2.47,1.42-4.46.27-4.46-2.58a9.87,9.87,0,0,1,4.46-7.74c2.47-1.42,4.47-.27,4.47,2.58A9.88,9.88,0,0,1,68.43,449.07Z",
    style: {
      fill: "#263238"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.43,446.08c-1,.6-1.88.11-1.88-1.08a4.16,4.16,0,0,1,1.88-3.26c1-.6,1.88-.11,1.88,1.09A4.15,4.15,0,0,1,68.43,446.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.86,416.49a3.16,3.16,0,0,1,3.14-.33c.82.46,3.66,2.13,4.47,2.58a3.12,3.12,0,0,1,1.32,2.9,9.9,9.9,0,0,1-4.46,7.74,3.17,3.17,0,0,1-3.13.33c-.83-.46-3.71-2.13-4.52-2.61a3.15,3.15,0,0,1-1.28-2.88A9.86,9.86,0,0,1,29.86,416.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.33,429.38c-2.47,1.42-4.47.27-4.47-2.58a9.88,9.88,0,0,1,4.47-7.74c2.46-1.42,4.46-.26,4.46,2.58A9.9,9.9,0,0,1,34.33,429.38Z",
    style: {
      fill: "#263238"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.33,426.39c-1,.6-1.88.11-1.88-1.08a4.16,4.16,0,0,1,1.88-3.26c1-.6,1.88-.11,1.88,1.09A4.17,4.17,0,0,1,34.33,426.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,432l-22.2,12.78a3.07,3.07,0,0,1-2.77,0L23.82,418.42a3.07,3.07,0,0,1-1.39-2.4v-5.91l48.44,28,25-14.39v5.91A3.09,3.09,0,0,1,94.46,432Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.87,438.08h0l25-14.39v5.91a3.09,3.09,0,0,1-1.38,2.4l-22.2,12.78a2.88,2.88,0,0,1-1.39.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1,442.42l0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05,322.16V411a2.89,2.89,0,0,0,1.2,2.65l49.8,28.75a2.89,2.89,0,0,1-1.15-2.61V351a12.81,12.81,0,0,1,5.79-10l21.72-12.51a3,3,0,0,1,2.68-.37L49.46,299.37a2.85,2.85,0,0,0-2.9.27l-21.73,12.5A12.84,12.84,0,0,0,19.05,322.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1,442.42l0,0,0,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.41,428.67,73,442.15c-2.25,1.3-4.09.23-4.09-2.36V350.94a12.83,12.83,0,0,1,5.79-10l21.72-12.5c2.25-1.29,4.09-.23,4.09,2.36v90.81A9.06,9.06,0,0,1,96.41,428.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.41,428.67,73,442.15c-2.25,1.3-4.09.23-4.09-2.36V350.94a12.83,12.83,0,0,1,5.79-10l21.72-12.5c2.25-1.29,4.09-.23,4.09,2.36v90.81A9.06,9.06,0,0,1,96.41,428.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.57,440.08l-4,2.32a2.57,2.57,0,0,1-2.56,0l-6.39-3.69v-4.5a.92.92,0,0,1,1.38-.8l3.87,2.24L75.19,432a.92.92,0,0,1,1.38.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,439.79v-4.14h0L75.19,432a.92.92,0,0,1,1.38.8v7.26l0,0-3.56,2a3.19,3.19,0,0,1-2.46.46,3.93,3.93,0,0,1-.43-.18A2.87,2.87,0,0,1,68.9,439.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25,413.65a2.88,2.88,0,0,1-1.2-2.64v-4.13h0l4.09,2.36a2.32,2.32,0,0,1,1.16,2V416Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,315.29l49.86,28.79a10.68,10.68,0,0,1,3.33-3.15l21.72-12.51a3,3,0,0,1,2.7-.37L49.45,299.36a2.87,2.87,0,0,0-2.89.29L24.84,312.14A11.29,11.29,0,0,0,21.5,315.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,307.08a5.28,5.28,0,0,1,4.8,0l2.4,1.38v.79L50.9,312l-2.4-1.39a1.68,1.68,0,0,1-1-1.39v-.78A1.68,1.68,0,0,1,48.5,307.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,308.46l-2.4-1.38a5.28,5.28,0,0,0-4.8,0c-1.32.76-1.32,2,0,2.77l2.4,1.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.9 307.46 50.9 311.24 55.7 308.46 55.7 304.69 50.9 307.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.89 321.37 50.9 307.46 55.7 304.69 79.69 318.55 74.89 321.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.69 322.32 79.69 318.55 74.89 321.37 74.89 325.09 79.69 322.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.91,325.09l4.8-2.77,2.39,1.38a1.66,1.66,0,0,1,1,1.37v.82a1.66,1.66,0,0,1-1,1.37,5.26,5.26,0,0,1-4.79,0l-2.4-1.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.69,322.32l2.4,1.38c1.32.77,1.32,2,0,2.77a5.28,5.28,0,0,1-4.8,0l-2.4-1.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.11 320.91 74.11 325.42 74.91 325.88 74.91 321.37 74.11 320.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.9 307.46 50.9 312.01 51.7 312.47 51.7 307.92 50.9 307.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.91 322.32 50.9 308.41 50.9 307.46 74.91 321.37 74.91 322.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.7 312.47 51.69 308.87 54.8 310.67 51.7 312.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,382.57,25,360.65c-1.12-.65-2,0-2,1.54V399c0,3.82,2.33,8.26,5.19,9.91L59.8,427.18c2.87,1.65,5.19-.1,5.19-3.92V386.44A4.84,4.84,0,0,0,63,382.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,379.86,25,358c-1.12-.65-2,0-2,1.53v36.81c0,3.82,2.33,8.26,5.19,9.91L59.8,424.47c2.87,1.66,5.19-.1,5.19-3.92V383.74A4.86,4.86,0,0,0,63,379.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.85 384.45 27.12 364.98 27.12 366.04 60.85 385.51 60.85 384.45",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.92,390.56l.68.4c.56.32,1-.1.89-.88l-.64-5.63-1.18-.68L59,388.65A2.14,2.14,0,0,0,59.92,390.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.47,330.66l35,20.22C63.43,352,65,355,65,357.55V373.9c0,2.57-1.56,3.75-3.49,2.64l-35-20.23c-1.93-1.11-3.5-4.1-3.5-6.67V333.3C23,330.72,24.54,329.54,26.47,330.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.47,328l35,20.22A8.38,8.38,0,0,1,65,354.85v16.34c0,2.57-1.56,3.76-3.49,2.64l-35-20.22a8.38,8.38,0,0,1-3.5-6.68V330.59C23,328,24.54,326.84,26.47,328Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.95 352.3 37.88 346.49 37.88 352.29 47.95 358.1 47.95 352.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,344.75l11.89,6.86v8.23L37,353Zm11,7.55-10.07-5.81v5.8L48,358.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.85 352.65 27.12 333.18 27.12 334.25 60.85 353.72 60.85 352.65",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.92,358.77l.68.4c.56.32,1-.1.89-.89l-.64-5.63L59.67,352,59,356.86A2.14,2.14,0,0,0,59.92,358.77Z",
    style: {
      fill: "#263238"
    }
  }))));
};
export { SvgReturned as ReactComponent };
export default "/bf4e9ad8b84e695f71a5b74449c9f3c6.svg";